// --- [PATCH: Filter Action Scroll Control] ---
var isFilterAction = false
if (!window.__customFilterFacetsFilterChangeBound) {
  window.__customFilterFacetsFilterChangeBound = true
  document.addEventListener("filter:change", () => {
    isFilterAction = true
    window.__applyGutterSpacerNow = true // enable spacer after first filter interaction
  })
}

if (window.quickFilterAlreadyInitialized) {
  // Already initialized, do not run this file again
} else {
  window.quickFilterAlreadyInitialized = true
  // If landing on a clean URL (no query params), clear any persisted quick-filter pills
  // to avoid showing a stale pill like "Massage Guns" by default.
  try {
    if (!window.location.search) {
      localStorage.removeItem("quickFilterOrderArr")
      localStorage.removeItem("quickFilterOrder")
    }
  } catch (_) {}
  window.__alreadyScrolledQuickFilter = false

  window.quickFilterAlreadyInitialized = true
  window.preventQuickScroll = false
  window.suppressNextPillScroll = false
  // Defer gutter spacer on initial page load; enable after first filter change
  // ============================================================================
  // Helpers
  // ============================================================================
  // Waits for quick filter pills to exist in the DOM, then invokes callback (with optional retries)
  function waitForQuickFilters(callback, retries = 10) {
    const quickFiltersExist = document.querySelector(
      ".quick-filter-main .custom-button.selected a",
    )
    if (quickFiltersExist) {
      callback()
    } else if (retries > 0) {
      setTimeout(() => waitForQuickFilters(callback, retries - 1), 100)
    } else {
      callback()
    }
  }

  // Gets the stored quick filter pill order array from localStorage
  function getPillOrderArr() {
    try {
      return JSON.parse(localStorage.getItem("quickFilterOrderArr") || "[]")
    } catch {
      return []
    }
  }
  // Stores the quick filter pill order array to localStorage
  function setPillOrderArr(arr) {
    localStorage.setItem("quickFilterOrderArr", JSON.stringify(arr))
  }
  let quickFilterPillOrder = 0
  // Resets all filters and reloads the page content and filters
  function resetAllFiltersAndReload() {
    // Reset user sort flags when clearing all filters
    window.userManuallySorted = false
    window.userSelectedSort = false

    // Restore active class to "Featured" sort option when clearing filters
    // BUT don't check the radio to prevent it from being included in filters
    const featuredRadio = document.querySelector(
      'input[name="sort_by"][value="manual"]',
    )
    if (featuredRadio) {
      // Don't check the radio - just add active class to show visual selection
      featuredRadio.checked = false

      const featuredLabel = featuredRadio.closest(".mobile-facets__label")
      if (featuredLabel) {
        featuredLabel.classList.add("active")
      }
    }

    const url = new URL(window.location.href)
    url.search = ""
    history.replaceState({}, "", url.pathname)

    // Collapse/remove mobile gutter on Clear
    try {
      window.__applyGutterSpacerNow = false
      const spacer = document.querySelector(".quick-filter-gutter-spacer")
      if (spacer) updateQuickFilterSpacer(spacer, { forceCollapse: true })
    } catch (error) {
      // Error handling for mobile gutter collapse
    }

    if (typeof window.loadContent === "function") {
      window.loadContent()
      initBadges()
      checkProductCardsPromoTextHeight()
    } else if (typeof loadContent === "function") {
      loadContent()
      initBadges()
      checkProductCardsPromoTextHeight()
    }

    if (typeof window.renderFilters === "function") {
      window.renderFilters()
    } else if (typeof renderFilters === "function") {
      renderFilters()
    }

    if (
      typeof filterSelectionTag !== "undefined" &&
      typeof filterSelectionTag.track === "function"
    ) {
      filterSelectionTag.track()
    }

    // Always scroll to left after clearing for consistent behavior
    if (typeof window.scrollQuickFilterMainLeft === "function") {
      setTimeout(() => {
        window.scrollQuickFilterMainLeft()
      }, 100)
    } else {
      // Fallback: manually scroll the container to the left with proper gutter
      const container = document.querySelector(".quick-filter-main")
      if (container) {
        const mobileGutter = getMobileGutterPx()
        scrollLeftCompat(container, true, mobileGutter)
      }
    }

    // Additional fallback: ensure container is positioned correctly even without pills
    setTimeout(() => {
      const container = document.querySelector(".quick-filter-main")
      if (container) {
        const mobileGutter = getMobileGutterPx()
        scrollLeftCompat(container, true, mobileGutter)
      }
    }, 200)

    // Adjust gap based on pill count after clearing
    if (typeof window.adjustQuickFilterMainGap === "function") {
      window.adjustQuickFilterMainGap()
    } else if (typeof adjustQuickFilterMainGap === "function") {
      adjustQuickFilterMainGap()
    }

    // Fallback: manually clear pills and reset filter state if functions aren't available
    if (
      typeof window.loadContent !== "function" ||
      typeof window.renderFilters !== "function"
    ) {
      // Clear all quick filter pills
      const pillContainer = document.querySelector(".quick-filters-container")
      if (pillContainer) {
        const pills = pillContainer.querySelectorAll(".quick-filter-pill")
        pills.forEach((pill) => pill.remove())
      }

      // Reset any active filter states
      const activeFilters = document.querySelectorAll(
        ".filter-group input:checked, .mobile-facets__checkbox:checked",
      )
      activeFilters.forEach((input) => {
        if (input.type === "radio" && input.value === "manual") {
          // Don't uncheck the Featured sort, just remove checked attribute
          input.removeAttribute("checked")
        } else {
          input.checked = false
        }
      })

      // Update visibility of clear buttons
      if (typeof window.toggleClearFiltersVisibility === "function") {
        window.toggleClearFiltersVisibility()
      }

      // Scroll to left after clearing (even if no pills, this ensures proper positioning)
      if (typeof window.scrollQuickFilterMainLeft === "function") {
        setTimeout(() => {
          window.scrollQuickFilterMainLeft()
        }, 100)
      } else {
        // Fallback: manually scroll the container to the left with proper gutter
        const container = document.querySelector(".quick-filter-main")
        if (container) {
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(container, true, mobileGutter)
        }
      }

      // Additional fallback: ensure container is positioned correctly even without pills
      setTimeout(() => {
        const container = document.querySelector(".quick-filter-main")
        if (container) {
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(container, true, mobileGutter)
        }
      }, 200)
    }
  }
  window.skipScrollBecauseOfQuickFilterClick = false
  document.addEventListener("mousedown", function (event) {
    const isQuickFilter = event.target.closest(".quick-filter-pill")
    window.skipScrollBecauseOfQuickFilterClick = !!isQuickFilter
  })
  // Scrolls the quick filter container to the left, unless a pill click prevents it
  function tryScrollLeft() {
    if (window.skipScrollBecauseOfQuickFilterClick) {
      window.skipScrollBecauseOfQuickFilterClick = false
      return
    }
    if (window.quickFilterClickPreventScroll) {
      return
    }
    const pillContainer = document.querySelector(".quick-filter-main")
    if (pillContainer) {
      const mobileGutter = getMobileGutterPx()
      scrollLeftCompat(pillContainer, true, mobileGutter)
      requestAnimationFrame(() =>
        scrollLeftCompat(pillContainer, true, mobileGutter),
      )
      setTimeout(() => scrollLeftCompat(pillContainer, true, mobileGutter), 60)
    }
  }
  // Gets the legacy quick filter pill order from localStorage
  function getPillOrder() {
    return JSON.parse(localStorage.getItem("quickFilterOrder") || "[]")
  }
  // Sets the legacy quick filter pill order in localStorage
  function setPillOrder(order) {
    localStorage.setItem("quickFilterOrder", JSON.stringify(order))
  }
  // Builds a unique key for a filter pill
  function getPillKey(key, value) {
    return key + "-" + value
  }
  // Creates a DOM element from an HTML string
  function createElementFromHTML(htmlString) {
    const div = document.createElement("div")
    div.innerHTML = htmlString.trim()
    return div.firstChild
  }
  // Cross-browser scroll-left helper with iOS fallback (ensures left snap on Safari iOS)
  function scrollLeftCompat(el, smooth = true, left = 0) {
    try {
      if (!el) return

      const isIOS =
        /iP(ad|hone|od)/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      const supportsSmooth = "scrollBehavior" in document.documentElement.style
      const target = Math.max(
        0,
        Math.min(left, el.scrollWidth - el.clientWidth),
      )

      if (isIOS) {
        // Multiple assertions to defeat momentum/ignored smooth scroll
        el.scrollLeft = target
        requestAnimationFrame(() => {
          el.scrollLeft = target
        })
        setTimeout(() => {
          el.scrollLeft = target
        }, 60)
      } else if (smooth && supportsSmooth && el.scrollTo) {
        el.scrollTo({ left: target, behavior: "smooth" })
      } else {
        el.scrollLeft = target
      }
    } catch (_) {}
  }

  // ============================================================================
  // Client-side quick filter: Yotpo rating min (URL-driven, e.g. ?yotpo_rating_min=4.6)
  // ============================================================================
  ;(function initYotpoRatingQuickFilter() {
    if (window.__yotpoRatingQuickFilterInitialized) return
    window.__yotpoRatingQuickFilterInitialized = true

    const PARAM_KEY = "yotpo_rating_min"
    const HIDDEN_CLASS = "yotpo-rating-filter-hidden"
    const YOTPO_RATING_CACHE_KEY = "__yotpoRatingCache"
    const YOTPO_RATING_SERVER_TOTALS_KEY = "__yotpoRatingServerTotals"
    const OVERLAY_ID = "yotpo-rating-filter-overlay"
    const OVERLAY_STYLE_ID = "yotpo-rating-filter-overlay-style"
    const APPENDED_ATTR = "data-yotpo-rating-appended"
    // Performance note:
    // Loading every page client-side to compute rating-filter results can be very slow (many seconds).
    // Default to filtering across ALL products when the rating filter is active.
    // To enable the faster "only filter currently-loaded products" behavior, set:
    //   window.__yotpoRatingLoadAllProducts = false
    // before this script runs.
    function shouldLoadAllProductsForRatingFilter() {
      if (window.__yotpoRatingLoadAllProducts === true) return true
      if (window.__yotpoRatingLoadAllProducts === false) return false
      return getSelectedMinRating() != null
    }
    const APPLY_RETRY_DELAY_MS = 200
    const APPLY_RETRY_MAX_ATTEMPTS = 15

    const yotpoRatingTools = (function getOrCreateYotpoRatingTools() {
      const cache =
        window[YOTPO_RATING_CACHE_KEY] || (window[YOTPO_RATING_CACHE_KEY] = {})
      return { cache }
    })()

    const yotpoRatingServerTotals = (function getOrCreateServerTotals() {
      const totals =
        window[YOTPO_RATING_SERVER_TOTALS_KEY] ||
        (window[YOTPO_RATING_SERVER_TOTALS_KEY] = {})
      return { totals }
    })()

    function parsePositiveInt(text) {
      const n = parseInt(String(text || "").replace(/[^\d]/g, ""), 10)
      return Number.isFinite(n) && n > 0 ? n : 0
    }

    function parseLastPositiveInt(text) {
      const matches = String(text || "").match(/\d[\d,]*/g) || []
      const last = matches.length ? matches[matches.length - 1] : ""
      const n = parseInt(String(last).replace(/,/g, ""), 10)
      return Number.isFinite(n) && n > 0 ? n : 0
    }

    function getAllProductsTotalFromDom() {
      try {
        const el = document.querySelector("#CollectionTrueTotal")
        const raw = el?.getAttribute?.("data-collection-total") || ""
        return parsePositiveInt(raw)
      } catch (_) {
        return 0
      }
    }

    function setProductCountText(visibleCount, totalCount) {
      const countEls = [
        document.querySelector("#ProductCount"),
        document.querySelector("#ProductCountDesktop"),
      ].filter(Boolean)
      if (!countEls.length) return

      const templatesEl = document.querySelector("#CollectionTrueTotal")
      const visible = Math.max(
        0,
        parseInt(String(visibleCount || "0"), 10) || 0,
      )
      const total = Math.max(0, parseInt(String(totalCount || "0"), 10) || 0)
      const effectiveTotal = total || visible

      if (templatesEl) {
        const isSimple = visible === effectiveTotal
        if (isSimple) {
          const simpleT =
            visible === 1
              ? templatesEl.getAttribute("data-product-count-one") || ""
              : templatesEl.getAttribute("data-product-count-other") || ""
          if (simpleT) {
            // Match `snippets/facets.liquid` behavior:
            // - unfiltered => show "{{ count }} Products"
            // - filtered => show "{{ product_count }} of {{ count }} products"
            let text = simpleT
              .replace("[COUNT]", String(visible))
              .replace("{{ count }}", String(visible))
              .replace("[VISIBLE]", String(visible))
              .replace("[TOTAL]", String(visible))
              .replace("{{ product_count }}", String(visible))

            // Mirror the theme's (English-only) capitalization tweak for the simple count.
            text = text
              .replace("products", "Products")
              .replace("product", "Product")

            countEls.forEach((el) => {
              el.textContent = text
            })
            return
          }
        }

        const filteredT =
          templatesEl.getAttribute("data-product-count") ||
          "{{ product_count }} of {{ count }} Products"
        const text = filteredT
          .replace("{{ product_count }}", String(visible))
          .replace("[VISIBLE]", String(visible))
          .replace("{{ count }}", String(effectiveTotal))
          .replace("[TOTAL]", String(effectiveTotal))

        countEls.forEach((el) => {
          el.textContent = text
        })
        return
      }

      // Fallback: only update the first number if we don't have translated templates.
      countEls.forEach((el) => {
        try {
          const txt = String(el.textContent || "")
          const m = txt.match(/\d[\d,]*/g)
          if (!m || !m.length) return
          const updated = txt.replace(m[0], String(visible))
          el.textContent = updated
        } catch (_) {}
      })
    }

    function removeRatingAppendedProducts() {
      const grid = getGridEl()
      if (!grid) return
      try {
        grid
          .querySelectorAll(`li.grid__item[${APPENDED_ATTR}]`)
          .forEach((li) => li.remove())
      } catch (_) {}
    }

    function ensureOverlayStyles() {
      if (document.getElementById(OVERLAY_STYLE_ID)) return
      const style = document.createElement("style")
      style.id = OVERLAY_STYLE_ID
      style.textContent = `
        #${OVERLAY_ID} {
          position: absolute;
          inset: 0;
          display: none;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 24px;
          background: rgba(255, 255, 255, 0.85);
          z-index: 50;
        }
        #${OVERLAY_ID}[aria-hidden="false"] { display: flex; }
        #${OVERLAY_ID} .yotpo-rating-filter-spinner {
          width: 32px;
          height: 32px;
          border: 3px solid rgba(0, 0, 0, 0.15);
          border-top-color: rgba(0, 0, 0, 0.55);
          border-radius: 50%;
          animation: yotpoRatingFilterSpin 0.8s linear infinite;
          margin: 0 auto 10px;
        }
        #${OVERLAY_ID} .yotpo-rating-filter-text {
          font-size: 14px;
          line-height: 1.35;
          color: rgba(0, 0, 0, 0.7);
        }
        @keyframes yotpoRatingFilterSpin { to { transform: rotate(360deg); } }
      `
      document.head.appendChild(style)
    }

    function ensureOverlayEl(host) {
      if (!host) return null
      ensureOverlayStyles()

      try {
        const cs = window.getComputedStyle(host)
        if (cs && cs.position === "static") host.style.position = "relative"
      } catch (_) {}

      let overlay = document.getElementById(OVERLAY_ID)
      if (!overlay) {
        overlay = document.createElement("div")
        overlay.id = OVERLAY_ID
        overlay.setAttribute("aria-hidden", "true")
        overlay.setAttribute("role", "status")
        overlay.innerHTML = `
          <div>
            <div class="yotpo-rating-filter-spinner"></div>
            <div class="yotpo-rating-filter-text">Filtering by rating…</div>
          </div>
        `
      }
      if (!host.contains(overlay)) host.appendChild(overlay)
      return overlay
    }

    function setOverlayText(text) {
      try {
        const overlay = document.getElementById(OVERLAY_ID)
        const el = overlay?.querySelector?.(".yotpo-rating-filter-text")
        if (el) el.textContent = text
      } catch (_) {}
    }

    function shouldShowRatingFilterOverlay() {
      // Default OFF to match other filters (no full-screen overlay).
      return window.__yotpoRatingShowOverlay === true
    }

    function setRatingFilterLoading(isLoading) {
      if (!shouldShowRatingFilterOverlay()) {
        // Ensure any existing overlay is hidden.
        try {
          const overlay = document.getElementById(OVERLAY_ID)
          if (overlay) overlay.setAttribute("aria-hidden", "true")
        } catch (_) {}
        try {
          const host =
            document.querySelector("#ProductGridContainer") ||
            document
              .querySelector("#product-grid")
              ?.closest?.("#ProductGridContainer") ||
            document.querySelector("#product-grid") ||
            null
          if (host) host.setAttribute("aria-busy", "false")
        } catch (_) {}
        return
      }

      const host =
        document.querySelector("#ProductGridContainer") ||
        document
          .querySelector("#product-grid")
          ?.closest?.("#ProductGridContainer") ||
        document.querySelector("#product-grid") ||
        null
      const overlay = ensureOverlayEl(host)
      if (!overlay) return
      overlay.setAttribute("aria-hidden", isLoading ? "false" : "true")
      try {
        host.setAttribute("aria-busy", isLoading ? "true" : "false")
      } catch (_) {}
      if (isLoading) setOverlayText("Loading…")
    }

    window.__setYotpoRatingFilterLoading = setRatingFilterLoading

    function getPills() {
      return Array.from(document.querySelectorAll(".yotpo-rating-filter-pill"))
    }

    function normalizeMin(val) {
      const v = parseFloat(String(val || "").trim())
      return Number.isFinite(v) ? String(v) : ""
    }

    function getSelectedMinFromUrl() {
      try {
        return new URLSearchParams(window.location.search).get(PARAM_KEY) || ""
      } catch (_) {
        return ""
      }
    }

    function getSelectedMinRating() {
      const selected = normalizeMin(getSelectedMinFromUrl())
      const v = parseFloat(selected)
      return Number.isFinite(v) ? v : null
    }

    function getQueryKeyWithoutPageAndRating(urlLike) {
      try {
        const u =
          urlLike instanceof URL
            ? new URL(urlLike.toString())
            : new URL(urlLike)
        u.searchParams.delete("page")
        u.searchParams.delete(PARAM_KEY)
        const sorted = new URLSearchParams()
        ;[...u.searchParams.entries()]
          .sort((a, b) => {
            if (a[0] !== b[0]) return a[0].localeCompare(b[0])
            return String(a[1]).localeCompare(String(b[1]))
          })
          .forEach(([k, v]) => sorted.append(k, v))
        return `${u.pathname}?${sorted.toString()}`
      } catch (_) {
        try {
          const u = new URL(window.location.href)
          u.searchParams.delete("page")
          u.searchParams.delete(PARAM_KEY)
          const sorted = new URLSearchParams()
          ;[...u.searchParams.entries()]
            .sort((a, b) => {
              if (a[0] !== b[0]) return a[0].localeCompare(b[0])
              return String(a[1]).localeCompare(String(b[1]))
            })
            .forEach(([k, v]) => sorted.append(k, v))
          return `${u.pathname}?${sorted.toString()}`
        } catch (_) {
          return `${window.location.pathname}|${window.location.search}`
        }
      }
    }

    function getCurrentQueryKeyWithoutPageAndRating() {
      return getQueryKeyWithoutPageAndRating(window.location.href)
    }

    function getServerTotalForCurrentQuery() {
      const key = getCurrentQueryKeyWithoutPageAndRating()
      const v = yotpoRatingServerTotals.totals[key]
      return typeof v === "number" && v > 0 ? v : 0
    }

    function setServerTotalForCurrentQuery(total) {
      const n = typeof total === "number" ? total : parsePositiveInt(total)
      if (!n) return
      const key = getCurrentQueryKeyWithoutPageAndRating()
      yotpoRatingServerTotals.totals[key] = n
    }

    function captureServerTotalFromDomIfMissing() {
      const key = getCurrentQueryKeyWithoutPageAndRating()
      if (typeof yotpoRatingServerTotals.totals[key] === "number") return

      const fromTemplates = getAllProductsTotalFromDom()
      const fromTotalEl = parsePositiveInt(
        document.querySelector(".custom-total-product")?.textContent || "",
      )
      const fromTopEl = parseLastPositiveInt(
        (
          document.querySelector("#ProductCount") ||
          document.querySelector("#ProductCountDesktop")
        )?.textContent || "",
      )
      const n = fromTemplates || fromTopEl || fromTotalEl
      if (n) yotpoRatingServerTotals.totals[key] = n
    }

    function syncPillUI() {
      const selectedRaw = normalizeMin(getSelectedMinFromUrl())
      const pills = getPills()
      pills.forEach((pill) => {
        const raw = normalizeMin(pill.getAttribute("data-rating-min") || "")
        const isSelected = raw && selectedRaw && raw === selectedRaw
        pill.setAttribute("aria-pressed", isSelected ? "true" : "false")
        pill.classList.toggle("selected", isSelected)
        pill.closest(".custom-button")?.classList.toggle("selected", isSelected)
      })
    }

    function getCardYotpoProductId(li) {
      const widget = li.querySelector(".yotpo-widget-instance")
      return (
        (widget?.getAttribute("data-yotpo-product-id") || "").trim() || null
      )
    }

    function getYotpoAriaLabelEl(widget) {
      // Match footer.liquid logic loosely (Yotpo markup varies).
      return (
        widget.querySelector(".yotpo-sr-bottom-line-summary [aria-label]") ||
        widget.querySelector('[aria-label*="out"]') ||
        widget.querySelector("[aria-label]") ||
        null
      )
    }

    function parseRatingFromAriaLabel(label) {
      const text = String(label || "")
      const tokens = []
      const re = /(\d+(?:[.,]\d+)?)/g
      let match
      while ((match = re.exec(text))) {
        const raw = match[1]
        const n = parseFloat(raw.replace(",", "."))
        if (!Number.isFinite(n)) continue
        tokens.push({ raw, n })
      }
      if (!tokens.length) return null
      const scaleIdx = tokens.findIndex((t) => Math.abs(t.n - 5) < 0.0001)
      const candidate = scaleIdx > 0 ? tokens[scaleIdx - 1] : tokens[0]
      if (!candidate || candidate.n < 0 || candidate.n > 5) return null
      return candidate.n
    }

    function readCardRating(li) {
      const widget = li.querySelector(".yotpo-widget-instance")
      if (
        widget?.classList?.contains("yotpo-card-ready") &&
        widget?.classList?.contains("yotpo-card-suppressed")
      ) {
        return 0
      }

      // Fast path: metafield-driven rating (rendered into `data-yotpo-score`).
      // This avoids waiting for Yotpo's async markup.
      const metaScore = parseFloat(
        (widget?.getAttribute?.("data-yotpo-score") || "").trim(),
      )
      if (Number.isFinite(metaScore)) return metaScore

      // Fallback: our injected rating number.
      const el = li.querySelector(
        ".yotpo-widget-instance .custom-yotpo-rating-number",
      )
      if (el) {
        const v = parseFloat((el.textContent || "").trim())
        return Number.isFinite(v) ? v : null
      }

      // Faster fallback: parse from Yotpo's own aria-label (often available before our injected number).
      if (widget) {
        const labelEl = getYotpoAriaLabelEl(widget)
        const label = labelEl?.getAttribute?.("aria-label") || ""
        const parsed = parseRatingFromAriaLabel(label)
        if (Number.isFinite(parsed)) return parsed
      }

      // If no rating data exists (no metafield and no Yotpo markup), treat as unrated.
      // This keeps the rating filter fast and prevents long "pending" cycles.
      return 0
    }

    function getSwatchInputs(li) {
      return Array.from(
        li.querySelectorAll(".custom-swatches-check[data-yotpo-product-id]"),
      )
    }

    function getCachedRating(yotpoProductId) {
      if (!yotpoProductId) return null
      const v = yotpoRatingTools.cache[String(yotpoProductId)]
      return typeof v === "number" ? v : null
    }

    function cacheCardRating(li) {
      const id = getCardYotpoProductId(li)
      const rating = readCardRating(li)
      if (id && typeof rating === "number") {
        yotpoRatingTools.cache[String(id)] = rating
      }
      return { id, rating }
    }

    function getGridEl() {
      return (
        document.getElementById("product-grid") ||
        document.querySelector("#ProductGridContainer #product-grid") ||
        document.querySelector("#ProductGridContainer") ||
        null
      )
    }

    function clearAutoSwatchState(li) {
      try {
        delete li.dataset.yotpoRatingAutoSwatch
      } catch (_) {}
    }

    function isUserSwatchCooldownActive(li) {
      try {
        const raw = (li?.dataset?.yotpoRatingUserSwatchTs || "").trim()
        const ts = parseInt(raw, 10)
        if (!Number.isFinite(ts) || ts <= 0) return false
        const cooldownMs =
          typeof window.__yotpoRatingUserSwatchCooldownMs === "number"
            ? window.__yotpoRatingUserSwatchCooldownMs
            : 1500
        return Date.now() - ts < Math.max(0, cooldownMs)
      } catch (_) {
        return false
      }
    }

    function applyRatingFilterOnce() {
      const min = getSelectedMinRating()
      if (min == null) return { ready: true, filtered: 0, total: 0 }
      const grid = getGridEl()
      if (!grid) return { ready: false, filtered: 0, total: 0 }

      const items = Array.from(
        grid.querySelectorAll("li.grid__item:not(.daily-deals-injected)"),
      )
      let filtered = 0
      let readyCount = 0
      let hasPending = false

      items.forEach((li) => {
        const { id, rating } = cacheCardRating(li)
        if (typeof rating === "number") readyCount++

        // If current selected swatch meets the rule, keep it.
        if (typeof rating === "number" && rating >= min) {
          li.classList.remove(HIDDEN_CLASS)
          return
        }

        // If any known swatch rating meets the rule, switch to it and keep the card.
        // IMPORTANT: Do not override a user-selected swatch immediately after a click.
        if (isUserSwatchCooldownActive(li)) {
          li.classList.remove(HIDDEN_CLASS)
          return
        }
        const swatches = getSwatchInputs(li)
        const cachedWinner = swatches.find((input) => {
          const sid = (input.getAttribute("data-yotpo-product-id") || "").trim()
          const r = getCachedRating(sid)
          return typeof r === "number" && r >= min
        })
        if (cachedWinner) {
          const sid = (
            cachedWinner.getAttribute("data-yotpo-product-id") || ""
          ).trim()
          const autoKey = `${min}:${sid}`
          if (li.dataset.yotpoRatingAutoSwatch !== autoKey) {
            li.dataset.yotpoRatingAutoSwatch = autoKey
            if (!cachedWinner.classList.contains("active")) cachedWinner.click()
          }
          li.classList.remove(HIDDEN_CLASS)
          return
        }

        // If rating is not ready yet, keep the card visible and retry later.
        // (Avoids hiding all cards during Yotpo load, and prevents feedback loops.)
        if (rating == null) {
          li.classList.remove(HIDDEN_CLASS)
          hasPending = true
          return
        }

        li.classList.add(HIDDEN_CLASS)
        filtered++
      })

      // If none of the cards have ratings yet, we are not ready (Yotpo still loading)
      return {
        ready: readyCount > 0 && !hasPending,
        filtered,
        total: items.length,
      }
    }

    function setPillVisible(pill, visible) {
      const wrap = pill.closest(".custom-button") || pill
      wrap.style.display = visible ? "" : "none"
    }

    let lastVisibilityKey = ""
    let visibilityRetryCount = 0
    let visibilityCheckInFlight = false
    let autoClearSelectedRatingInProgress = false
    let nonRatingOptionSyncToken = 0
    let nonRatingOptionSyncTimer = null
    let nonRatingOptionSyncAbortController = null
    const HIDDEN_BY_RATING_ATTR = "data-hidden-by-rating"
    const intersectionEligibilityCache = new Map()
    const optionIneligibleFloorByKey = new Map()
    const optionSyncDomParser = new DOMParser()
    let lastNonRatingOptionSyncKey = ""
    let nonRatingOptionSyncRetryCount = 0
    let nonRatingOptionSyncRetryTimer = null
    const OPTION_SYNC_CONCURRENCY =
      typeof window.__yotpoRatingOptionSyncConcurrency === "number"
        ? window.__yotpoRatingOptionSyncConcurrency
        : 6
    const OPTION_SYNC_FAST_PAGE_LIMIT =
      typeof window.__yotpoRatingOptionSyncFastPageLimit === "number"
        ? window.__yotpoRatingOptionSyncFastPageLimit
        : 1
    const OPTION_SYNC_SCHEDULE_DELAY_MS =
      typeof window.__yotpoRatingOptionSyncDelayMs === "number"
        ? window.__yotpoRatingOptionSyncDelayMs
        : 80

    function getNonRatingOptionSyncKey() {
      const min = getSelectedMinRating()
      if (min == null) return ""
      // Note: key excludes `yotpo_rating_min` + `page` via `getCurrentQueryKeyWithoutPageAndRating`.
      return `${min}|${getCurrentQueryKeyWithoutPageAndRating()}`
    }

    function clearNonRatingOptionSyncTimers() {
      if (nonRatingOptionSyncTimer) clearTimeout(nonRatingOptionSyncTimer)
      nonRatingOptionSyncTimer = null
      if (nonRatingOptionSyncRetryTimer)
        clearTimeout(nonRatingOptionSyncRetryTimer)
      nonRatingOptionSyncRetryTimer = null
      nonRatingOptionSyncRetryCount = 0
    }

    function restoreNonRatingOptionsHiddenByRating() {
      clearNonRatingOptionSyncTimers()
      lastNonRatingOptionSyncKey = ""
      try {
        optionIneligibleFloorByKey.clear()
      } catch (_) {}
      try {
        nonRatingOptionSyncAbortController?.abort()
      } catch (_) {}
      nonRatingOptionSyncAbortController = null
      try {
        document
          .querySelectorAll(`[${HIDDEN_BY_RATING_ATTR}="1"]`)
          .forEach((el) => {
            el.removeAttribute(HIDDEN_BY_RATING_ATTR)
            el.style.display = ""
          })
      } catch (_) {}
    }

    function getFirstFilterParamFromSearchParams(params) {
      try {
        for (const [k, v] of params.entries()) {
          if (!k) continue
          if (k === PARAM_KEY) continue
          if (k === "page") continue
          if (k.startsWith("filter.")) return { key: k, value: v }
        }
      } catch (_) {}
      return null
    }

    function getCurrentServerParamsWithoutRatingAndPage() {
      const params = new URLSearchParams(window.location.search || "")
      params.delete(PARAM_KEY)
      params.delete("page")
      return params
    }

    function isOptionActiveInCurrentUrl(key, value) {
      try {
        const params = new URLSearchParams(window.location.search || "")
        const values = params.getAll(key) || []
        return values.includes(value)
      } catch (_) {
        return false
      }
    }

    function collectQuickFilterRowOptions() {
      const links = Array.from(
        document.querySelectorAll(
          ".quick-filter-main .multiple-custom-block .custom-button a",
        ),
      ).filter((a) => a && !a.classList.contains("yotpo-rating-filter-pill"))

      const out = []
      for (const a of links) {
        let u
        try {
          u = new URL(a.href, window.location.origin)
        } catch (_) {
          continue
        }
        // Only sync options that apply to the current PLP.
        if (u.pathname !== window.location.pathname) continue
        const kv = getFirstFilterParamFromSearchParams(u.searchParams)
        if (!kv) continue
        out.push({
          key: kv.key,
          value: kv.value,
          button: a,
          buttonWrap: a.closest(".custom-button"),
        })
      }
      return out
    }

    function getNextPageFromDoc(doc, currentPage) {
      try {
        const btn = doc.querySelector(".load-more-btn")
        const raw = btn?.getAttribute?.("data-page") || ""
        const n = parseInt(raw, 10)
        if (!Number.isFinite(n) || n <= currentPage) return null
        return n
      } catch (_) {
        return null
      }
    }

    function parseProductIdsFromDoc(doc) {
      try {
        const grid =
          doc.querySelector("#product-grid") ||
          doc.querySelector("#ProductGridContainer #product-grid") ||
          doc.querySelector("#ProductGridContainer")
        if (!grid) return []
        const cards = Array.from(grid.querySelectorAll(".card[data-prod-id]"))
        return cards
          .map((c) => String(c.getAttribute("data-prod-id") || "").trim())
          .filter(Boolean)
      } catch (_) {
        return []
      }
    }

    function hasAnyEligibleRatingForProductIds(ids, min) {
      let hasUnknown = false
      for (const id of ids) {
        const r = getCachedRating(id)
        if (typeof r === "number") {
          if (r >= min) return { hasAny: true, hasUnknown: false }
          continue
        }
        hasUnknown = true
      }
      return { hasAny: false, hasUnknown }
    }

    function getComparableParamsState(params) {
      const map = new Map()
      let priceGte = null
      let priceLte = null
      try {
        for (const [k, v] of params.entries()) {
          if (!k) continue
          if (k === PARAM_KEY) continue
          if (k === "page") continue
          if (k === "sort_by") continue
          if (k === "filter.v.price.gte") {
            const n = parseFloat(String(v || ""))
            priceGte = Number.isFinite(n) ? n : priceGte
            continue
          }
          if (k === "filter.v.price.lte") {
            const n = parseFloat(String(v || ""))
            priceLte = Number.isFinite(n) ? n : priceLte
            continue
          }
          if (!map.has(k)) map.set(k, [])
          map.get(k).push(String(v))
        }
      } catch (_) {}

      try {
        for (const [k, arr] of map.entries()) {
          arr.sort()
          map.set(k, arr)
        }
      } catch (_) {}

      return { map, priceGte, priceLte }
    }

    // Returns true when `current` is narrower-or-equal than `base`:
    // - adding new keys narrows (AND)
    // - removing values from an existing key narrows (OR fewer)
    // - adding values to an existing key broadens (OR more) => false
    function isNarrowerOrEqualParamsState(current, base) {
      if (!base) return false
      const cur = current?.map || new Map()
      const bas = base?.map || new Map()

      // If the base has a key that current lacks, current is broader.
      for (const key of bas.keys()) {
        if (!cur.has(key)) return false
      }

      // For shared keys: current values must be a subset of base values.
      for (const [key, curVals] of cur.entries()) {
        if (!bas.has(key)) continue // new constraint => narrower (OK)
        const baseVals = bas.get(key) || []
        for (const v of curVals || []) {
          if (!baseVals.includes(v)) return false
        }
      }

      // Price range monotonicity
      const curGte = current?.priceGte
      const curLte = current?.priceLte
      const baseGte = base?.priceGte
      const baseLte = base?.priceLte

      if (typeof baseGte === "number") {
        if (typeof curGte !== "number") return false
        if (curGte < baseGte) return false
      }
      if (typeof baseLte === "number") {
        if (typeof curLte !== "number") return false
        if (curLte > baseLte) return false
      }

      return true
    }

    function getOptionFloorKey(min, key, value) {
      return `${min}|${key}|${value}`
    }

    function applyOptionIneligibleFloor(min, optKey, optValue, paramsState) {
      const floorKey = getOptionFloorKey(min, optKey, optValue)
      const floor = optionIneligibleFloorByKey.get(floorKey)
      if (!floor) return false
      return isNarrowerOrEqualParamsState(paramsState, floor)
    }

    function recordOptionIneligibleFloor(min, optKey, optValue, paramsState) {
      const floorKey = getOptionFloorKey(min, optKey, optValue)
      const existing = optionIneligibleFloorByKey.get(floorKey)
      if (!existing) {
        optionIneligibleFloorByKey.set(floorKey, paramsState)
        return
      }
      // Keep the broadest known "ineligible" floor for this option.
      // If the existing floor is narrower than the new one, replace it.
      if (isNarrowerOrEqualParamsState(existing, paramsState)) {
        optionIneligibleFloorByKey.set(floorKey, paramsState)
      }
    }

    function buildOptionSyncFetchUrl(searchParams) {
      try {
        const base = new URL(window.location.pathname, window.location.origin)
        const sectionId =
          document.getElementById("product-grid")?.dataset?.id || ""
        if (sectionId) base.searchParams.set("section_id", sectionId)
        for (const [k, v] of searchParams.entries())
          base.searchParams.append(k, v)
        return base.toString()
      } catch (_) {
        return ""
      }
    }

    async function serverQueryHasEligibleRatedProduct(
      params,
      min,
      token,
      signal,
    ) {
      // Cache by query (no page, no rating) + min rating.
      const baseUrl = new URL(window.location.href)
      baseUrl.search = params.toString()
      const cacheKey = `${min}|${getQueryKeyWithoutPageAndRating(baseUrl)}`
      if (intersectionEligibilityCache.has(cacheKey)) {
        return intersectionEligibilityCache.get(cacheKey)
      }

      let page = 1
      let sawUnknown = false
      for (let safety = 0; safety < 20; safety++) {
        if (token !== nonRatingOptionSyncToken) return null
        if (
          OPTION_SYNC_FAST_PAGE_LIMIT > 0 &&
          page > OPTION_SYNC_FAST_PAGE_LIMIT
        )
          return
        const sp = new URLSearchParams(params.toString())
        sp.delete("page")
        if (page > 1) sp.set("page", String(page))
        const fetchUrl = buildOptionSyncFetchUrl(sp)
        if (!fetchUrl) return null

        let html = ""
        try {
          const res = await fetch(fetchUrl, {
            credentials: "same-origin",
            signal,
          })
          if (!res.ok) break
          html = await res.text()
        } catch (e) {
          if (e?.name === "AbortError") return null
          break
        }
        if (token !== nonRatingOptionSyncToken) return null

        const doc = optionSyncDomParser.parseFromString(html, "text/html")
        const ids = parseProductIdsFromDoc(doc)
        if (!ids.length) break

        const { hasAny, hasUnknown } = hasAnyEligibleRatingForProductIds(
          ids,
          min,
        )
        if (hasAny) {
          intersectionEligibilityCache.set(cacheKey, true)
          return true
        }
        if (hasUnknown) sawUnknown = true

        const next = getNextPageFromDoc(doc, page)
        if (!next) break
        page = next
      }

      // If we saw unknown ratings, we can't confidently hide; return null so UI stays visible and can retry later.
      if (sawUnknown) return null

      intersectionEligibilityCache.set(cacheKey, false)
      return false
    }

    function setHiddenByRating(el, hidden) {
      if (!el) return
      if (hidden) {
        el.setAttribute(HIDDEN_BY_RATING_ATTR, "1")
        el.style.display = "none"
        return
      }
      if (el.getAttribute(HIDDEN_BY_RATING_ATTR) === "1") {
        el.removeAttribute(HIDDEN_BY_RATING_ATTR)
        el.style.display = ""
      }
    }

    function syncDrawerOptionVisibility(key, value, shouldHide) {
      const forms = [
        document.querySelector("#FacetFiltersFormMobile"),
        document.querySelector("#FacetFiltersForm"),
      ].filter(Boolean)
      forms.forEach((form) => {
        let input = null
        try {
          input = Array.from(
            form.querySelectorAll(`input[name="${key}"]`),
          ).find((el) => String(el.value || "") === String(value || ""))
        } catch (_) {
          input = null
        }
        if (!input) return
        const wrap =
          input.closest(".mobile-facets__label") ||
          input.closest("label") ||
          input.parentElement
        if (!wrap) return
        // Never hide a selected option (must remain removable).
        if (input.checked) {
          setHiddenByRating(wrap, false)
          return
        }
        setHiddenByRating(wrap, shouldHide)
      })
    }

    async function syncNonRatingQuickFiltersUnderRating() {
      const min = getSelectedMinRating()
      if (min == null) {
        restoreNonRatingOptionsHiddenByRating()
        return
      }

      const syncKey = getNonRatingOptionSyncKey()
      // Avoid restarting the whole sync repeatedly while Yotpo is still injecting DOM.
      // We’ll still retry a few times via the retry scheduler if results are unknown.
      if (
        syncKey &&
        syncKey === lastNonRatingOptionSyncKey &&
        nonRatingOptionSyncRetryCount === 0
      )
        return
      lastNonRatingOptionSyncKey = syncKey

      const token = (nonRatingOptionSyncToken = nonRatingOptionSyncToken + 1)
      try {
        nonRatingOptionSyncAbortController?.abort()
      } catch (_) {}
      nonRatingOptionSyncAbortController = null
      try {
        nonRatingOptionSyncAbortController = new AbortController()
      } catch (_) {
        nonRatingOptionSyncAbortController = null
      }
      const baseParams = getCurrentServerParamsWithoutRatingAndPage()
      const options = collectQuickFilterRowOptions()
      if (!options.length) return

      // Fast path: apply anything we already know from cache immediately.
      const pending = []
      for (const opt of options) {
        // Never hide the active option.
        const isActive = isOptionActiveInCurrentUrl(opt.key, opt.value)
        if (isActive) {
          setHiddenByRating(opt.buttonWrap, false)
          syncDrawerOptionVisibility(opt.key, opt.value, false)
          continue
        }

        const nextParams = new URLSearchParams(baseParams.toString())
        // IMPORTANT: For quick-filter buttons (Most Popular), treat each option as a *replacement*
        // within its group. Otherwise, when one Most Popular option is selected (e.g. FSA/HSA Eligible),
        // checking another option (e.g. Back Pain) would OR the values together and incorrectly look "eligible".
        if (opt.key === "filter.p.m.custom.most_popular") {
          nextParams.delete(opt.key)
          nextParams.append(opt.key, opt.value)
        } else {
          const existing = nextParams.getAll(opt.key) || []
          if (!existing.includes(opt.value))
            nextParams.append(opt.key, opt.value)
        }

        // Monotonic floor: if this option was already proven to have 0 eligible results under a broader (less-filtered)
        // query, it must still have 0 under any narrower (more-filtered) query. Keep it hidden immediately.
        const nextParamsState = getComparableParamsState(nextParams)
        if (
          applyOptionIneligibleFloor(min, opt.key, opt.value, nextParamsState)
        ) {
          setHiddenByRating(opt.buttonWrap, true)
          syncDrawerOptionVisibility(opt.key, opt.value, true)
          continue
        }
        const baseUrl = new URL(window.location.href)
        baseUrl.search = nextParams.toString()
        const cacheKey = `${min}|${getQueryKeyWithoutPageAndRating(baseUrl)}`
        if (intersectionEligibilityCache.has(cacheKey)) {
          const eligible = intersectionEligibilityCache.get(cacheKey)
          if (eligible === false) {
            setHiddenByRating(opt.buttonWrap, true)
            syncDrawerOptionVisibility(opt.key, opt.value, true)
            recordOptionIneligibleFloor(
              min,
              opt.key,
              opt.value,
              nextParamsState,
            )
          } else {
            setHiddenByRating(opt.buttonWrap, false)
            syncDrawerOptionVisibility(opt.key, opt.value, false)
          }
        } else {
          pending.push(opt)
        }
      }

      // Reset cache when min changes by scoping cacheKey to min; no-op here.
      // Small concurrency to avoid hammering the storefront.
      const queue = pending.slice()
      const concurrency = Math.max(1, Math.min(OPTION_SYNC_CONCURRENCY, 8))
      let anyUnknown = false

      const worker = async () => {
        while (queue.length) {
          if (token !== nonRatingOptionSyncToken) return
          const opt = queue.shift()
          if (!opt) continue

          // Never hide the active option.
          const isActive = isOptionActiveInCurrentUrl(opt.key, opt.value)
          if (isActive) {
            setHiddenByRating(opt.buttonWrap, false)
            syncDrawerOptionVisibility(opt.key, opt.value, false)
            continue
          }

          // Simulate adding this option to the current server-side filters.
          const nextParams = new URLSearchParams(baseParams.toString())
          if (opt.key === "filter.p.m.custom.most_popular") {
            nextParams.delete(opt.key)
            nextParams.append(opt.key, opt.value)
          } else {
            const existing = nextParams.getAll(opt.key) || []
            if (!existing.includes(opt.value))
              nextParams.append(opt.key, opt.value)
          }
          const nextParamsState = getComparableParamsState(nextParams)

          // If a prior ineligible floor proves this option must still be ineligible under this narrower state, skip fetch.
          if (
            applyOptionIneligibleFloor(min, opt.key, opt.value, nextParamsState)
          ) {
            setHiddenByRating(opt.buttonWrap, true)
            syncDrawerOptionVisibility(opt.key, opt.value, true)
            continue
          }

          const eligible = await serverQueryHasEligibleRatedProduct(
            nextParams,
            min,
            token,
            nonRatingOptionSyncAbortController?.signal,
          )
          if (token !== nonRatingOptionSyncToken) return

          // `null` means unknown (ratings not fully cached) => keep visible for now and retry a few times.
          // `undefined` means we stopped early due to fast-page limit => keep visible (no retry; it won’t improve).
          if (eligible === null) anyUnknown = true
          if (eligible === false) {
            setHiddenByRating(opt.buttonWrap, true)
            syncDrawerOptionVisibility(opt.key, opt.value, true)
            recordOptionIneligibleFloor(
              min,
              opt.key,
              opt.value,
              nextParamsState,
            )
          } else if (eligible === true) {
            setHiddenByRating(opt.buttonWrap, false)
            syncDrawerOptionVisibility(opt.key, opt.value, false)
          } else {
            // Unknown/fast-limit: don't change current UI state (prevents hidden options from reappearing incorrectly).
          }
        }
      }

      await Promise.all(Array.from({ length: concurrency }, worker))

      // If some options couldn’t be decided yet (ratings still loading), retry a few times.
      // This keeps UI responsive (first render is fast), while still converging to correct hide/show.
      if (anyUnknown && nonRatingOptionSyncRetryCount < 4) {
        nonRatingOptionSyncRetryCount += 1
        if (nonRatingOptionSyncRetryTimer)
          clearTimeout(nonRatingOptionSyncRetryTimer)
        nonRatingOptionSyncRetryTimer = setTimeout(() => {
          nonRatingOptionSyncRetryTimer = null
          // Clear the key so the next run isn't skipped.
          lastNonRatingOptionSyncKey = ""
          syncNonRatingQuickFiltersUnderRating()
        }, 600)
      } else {
        nonRatingOptionSyncRetryCount = 0
      }
    }

    function scheduleSyncNonRatingQuickFiltersUnderRating({
      immediate = false,
    } = {}) {
      // Option-sync is expensive and depends on having ratings cached.
      // When we are loading the full result set for rating-filter, defer sync until paging completes.
      if (
        shouldLoadAllProductsForRatingFilter() &&
        !isLoadAllCompleteForRatingFilter()
      ) {
        clearNonRatingOptionSyncTimers()
        lastNonRatingOptionSyncKey = ""
        try {
          nonRatingOptionSyncAbortController?.abort()
        } catch (_) {}
        nonRatingOptionSyncAbortController = null
        return
      }
      const syncKey = getNonRatingOptionSyncKey()
      if (
        syncKey &&
        syncKey === lastNonRatingOptionSyncKey &&
        nonRatingOptionSyncRetryCount === 0
      )
        return
      if (nonRatingOptionSyncTimer) clearTimeout(nonRatingOptionSyncTimer)
      nonRatingOptionSyncTimer = setTimeout(
        () => {
          nonRatingOptionSyncTimer = null
          syncNonRatingQuickFiltersUnderRating()
        },
        immediate ? 0 : OPTION_SYNC_SCHEDULE_DELAY_MS,
      )
    }

    function updateRatingPillVisibility() {
      const pills = getPills()
      if (!pills.length) return

      // Only re-check when the grid changes meaningfully.
      const grid = getGridEl()
      const count = grid
        ? grid.querySelectorAll("li.grid__item:not(.daily-deals-injected)")
            .length
        : 0
      const key = `${window.location.pathname}|${window.location.search}|${count}`
      if (
        key === lastVisibilityKey &&
        !visibilityCheckInFlight &&
        visibilityRetryCount === 0
      )
        return
      if (visibilityCheckInFlight) return
      lastVisibilityKey = key
      visibilityCheckInFlight = true

      try {
        const selectedRaw = normalizeMin(getSelectedMinFromUrl())
        const hasAnyReadyWidget = !!(
          grid && grid.querySelector(".yotpo-widget-instance.yotpo-card-ready")
        )
        const hasAnyRatingNumber = !!(
          grid &&
          grid.querySelector(
            ".yotpo-widget-instance .custom-yotpo-rating-number",
          )
        )
        const items = grid
          ? Array.from(
              grid.querySelectorAll("li.grid__item:not(.daily-deals-injected)"),
            )
          : []

        // If a server-side filter change results in a set of products with no ratings at all (e.g. all Yotpo cards
        // are suppressed/unrated), a previously-selected rating filter should be cleared so quick filters stay synced.
        // Otherwise the rating pill stays visible/selected even though it can never match anything in this result set.
        if (
          selectedRaw &&
          (hasAnyReadyWidget || hasAnyRatingNumber) &&
          items.length > 0 &&
          !autoClearSelectedRatingInProgress
        ) {
          let hasAnyRatedProduct = false
          for (const li of items) {
            const { rating } = cacheCardRating(li)
            if (typeof rating === "number" && rating > 0) {
              hasAnyRatedProduct = true
              break
            }
            const swatches = getSwatchInputs(li)
            if (
              swatches.some((s) => {
                const sid = (
                  s.getAttribute("data-yotpo-product-id") || ""
                ).trim()
                const r = getCachedRating(sid)
                return typeof r === "number" && r > 0
              })
            ) {
              hasAnyRatedProduct = true
              break
            }
          }

          if (!hasAnyRatedProduct) {
            autoClearSelectedRatingInProgress = true
            try {
              const url = new URL(window.location.href)
              url.searchParams.delete(PARAM_KEY)
              history.replaceState({}, "", url.toString())
            } catch (_) {}

            // Clear rating UI + restore default grid state without re-fetching server results.
            applyOrClear()

            setTimeout(() => {
              autoClearSelectedRatingInProgress = false
              try {
                document.dispatchEvent(new Event("filters:updated"))
              } catch (_) {}
              updateRatingPillVisibility()
            }, 0)
            return
          }
        }

        // Check each rating-min pill; hide it when there are no eligible products.
        for (const pill of pills) {
          const raw = normalizeMin(pill.getAttribute("data-rating-min") || "")
          if (!raw) continue

          // Never hide the currently-selected pill; users must be able to toggle it off.
          if (selectedRaw && raw === selectedRaw) {
            setPillVisible(pill, true)
            continue
          }

          const min = parseFloat(raw)
          if (!Number.isFinite(min)) continue

          // Fast path: any visible card already has rating >= min?
          let hasAny = false
          for (const li of items) {
            const { id, rating } = cacheCardRating(li)
            if (typeof rating === "number" && rating >= min) {
              hasAny = true
              break
            }
            // Check known swatches quickly
            const swatches = getSwatchInputs(li)
            if (
              swatches.some((s) => {
                const sid = (
                  s.getAttribute("data-yotpo-product-id") || ""
                ).trim()
                const r = getCachedRating(sid)
                return typeof r === "number" && r >= min
              })
            ) {
              hasAny = true
              break
            }
          }

          // If Yotpo hasn't populated ratings yet, keep pill visible and retry a few times.
          if (!hasAny && !hasAnyReadyWidget && !hasAnyRatingNumber) {
            setPillVisible(pill, true)
          } else {
            setPillVisible(pill, hasAny)
          }
        }
      } finally {
        visibilityCheckInFlight = false
      }

      if (
        !(
          grid &&
          grid.querySelector(
            ".yotpo-widget-instance .custom-yotpo-rating-number",
          )
        ) &&
        visibilityRetryCount < 8
      ) {
        visibilityRetryCount += 1
        setTimeout(updateRatingPillVisibility, 500)
      } else {
        visibilityRetryCount = 0
      }
    }

    function updateLoadMoreCountUI() {
      const grid =
        document.querySelector("#product-grid") ||
        document.querySelector("#ProductGridContainer")
      const countElem = document.querySelector(".custom-show-product")
      if (!grid || !countElem) return
      const visible = grid.querySelectorAll(
        "li.grid__item:not(.daily-deals-injected):not(.yotpo-rating-filter-hidden)",
      ).length
      countElem.textContent = String(visible)
    }

    const PLP_RATING_EMPTY_ID = "plp-rating-empty-state"

    function togglePlpRatingEmptyState(show) {
      let el = document.getElementById(PLP_RATING_EMPTY_ID)
      if (show && !el) {
        el = document.createElement("div")
        el.id = PLP_RATING_EMPTY_ID
        el.setAttribute("role", "status")
        el.style.cssText =
          "text-align:center;padding:60px 20px;grid-column:1/-1;"
        el.innerHTML =
          '<p style="font-size:18px;font-weight:500;margin:0 0 8px;color:#252525;">No products found</p>' +
          '<p style="font-size:14px;color:#6b6b6b;margin:0;">Use fewer filters or <a href="' +
          window.location.pathname +
          '" class="underlined-link link" style="color:inherit;">remove all</a></p>'
        const grid = getGridEl()
        if (grid) grid.appendChild(el)
      }
      if (el) el.style.display = show ? "" : "none"
    }

    function clearRatingFilter() {
      togglePlpRatingEmptyState(false)
      const grid = getGridEl()
      if (!grid) return
      grid
        .querySelectorAll(`li.grid__item.${HIDDEN_CLASS}`)
        .forEach((li) => li.classList.remove(HIDDEN_CLASS))
      grid
        .querySelectorAll("li.grid__item:not(.daily-deals-injected)")
        .forEach(clearAutoSwatchState)
      try {
        const totalEl = document.querySelector(".custom-total-product")
        if (totalEl && originalTotalText)
          totalEl.textContent = originalTotalText
      } catch (_) {}
      // After clearing, restore count based on current (server-side) grid
      try {
        const gridEl =
          document.querySelector("#product-grid") ||
          document.querySelector("#ProductGridContainer")
        const countElem = document.querySelector(".custom-show-product")
        if (gridEl && countElem) {
          const visible = gridEl.querySelectorAll(
            "li.grid__item:not(.daily-deals-injected)",
          ).length
          countElem.textContent = String(visible)
        }
      } catch (_) {}
    }

    let applyCycleInProgress = false
    let applyCycleQueued = false
    let applyCycleTimer = null
    let applyCycleAttempt = 0
    let applyCycleWaitAttempt = 0

    function isLoadAllCompleteForRatingFilter() {
      if (!shouldLoadAllProductsForRatingFilter()) return true
      try {
        captureOriginalTotal()
      } catch (_) {}
      const targetTotal = getTargetTotalCount()
      if (!targetTotal) return true
      return getLoadedProductCount() >= targetTotal
    }

    function stopApplyCycle() {
      applyCycleInProgress = false
      applyCycleQueued = false
      applyCycleAttempt = 0
      applyCycleWaitAttempt = 0
      if (applyCycleTimer) clearTimeout(applyCycleTimer)
      applyCycleTimer = null
    }

    function requestApplyCycle() {
      if (getSelectedMinRating() == null) return
      applyCycleQueued = true
      if (applyCycleInProgress) return
      applyCycleInProgress = true
      applyCycleQueued = false
      applyCycleAttempt = 0
      applyCycleWaitAttempt = 0
      applyCycleStep()
    }

    function applyCycleStep() {
      if (getSelectedMinRating() == null) {
        stopApplyCycle()
        togglePlpRatingEmptyState(false)
        return
      }

      const res = applyRatingFilterOnce()
      if (res.ready) {
        syncAllCountsForRatingFilter({
          isFinal: isLoadAllCompleteForRatingFilter(),
        })
        togglePlpRatingEmptyState(res.filtered === res.total && res.total > 0)
        applyCycleInProgress = false
        applyCycleAttempt = 0
        applyCycleWaitAttempt = 0
        if (applyCycleQueued) {
          applyCycleQueued = false
          requestApplyCycle()
        }
        return
      }

      applyCycleAttempt += 1
      if (applyCycleAttempt < APPLY_RETRY_MAX_ATTEMPTS) {
        applyCycleTimer = setTimeout(applyCycleStep, APPLY_RETRY_DELAY_MS)
      } else {
        // Give up; we will be re-triggered by observers/events when ratings arrive.
        applyCycleInProgress = false
        applyCycleAttempt = 0
        applyCycleWaitAttempt = 0
      }
    }

    function getTotalProductCount() {
      // Prefer cached server total to avoid any UI overrides while rating filter is active.
      const cached = getServerTotalForCurrentQuery()
      if (cached) return cached
      const fromTemplates = getAllProductsTotalFromDom()
      if (fromTemplates) return fromTemplates
      const fromTopEl = parseLastPositiveInt(
        (
          document.querySelector("#ProductCount") ||
          document.querySelector("#ProductCountDesktop")
        )?.textContent || "",
      )
      if (fromTopEl) return fromTopEl
      return parsePositiveInt(
        document.querySelector(".custom-total-product")?.textContent || "",
      )
    }

    let originalTotalText = null
    let originalTotalKey = ""

    function captureOriginalTotal() {
      captureServerTotalFromDomIfMissing()
      const key = getPageKeyWithoutPageParam()
      if (key !== originalTotalKey) {
        originalTotalKey = key
        originalTotalText = null
      }
      if (originalTotalText != null) return

      const cached = getServerTotalForCurrentQuery()
      if (cached) {
        originalTotalText = String(cached)
        return
      }
      const el = document.querySelector(".custom-total-product")
      if (!el) return
      const txt = (el.textContent || "").trim()
      if (txt) originalTotalText = txt
    }

    function getTargetTotalCount() {
      const cached = getServerTotalForCurrentQuery()
      if (cached) return cached
      const n = parsePositiveInt(originalTotalText || "")
      return n || getTotalProductCount()
    }

    function getLoadedProductCount() {
      const grid = getGridEl()
      if (!grid) return 0
      return grid.querySelectorAll("li.grid__item:not(.daily-deals-injected)")
        .length
    }

    function getPerPageCount() {
      const raw = document.querySelector(".custom-show-product")?.dataset
        ?.perPage
      const n = parseInt(raw || "", 10)
      return Number.isFinite(n) && n > 0 ? n : 36
    }

    function getPageKeyWithoutPageParam() {
      return getCurrentQueryKeyWithoutPageAndRating()
    }

    async function appendPageProducts(page, token) {
      try {
        if (token !== loadAllToken) return 0
        if (getSelectedMinRating() == null) return 0

        const baseUrl =
          document.querySelector(".load-more-btn")?.dataset?.baseUrl ||
          window.location.pathname.split("?")[0] ||
          window.location.pathname

        const query = new URLSearchParams(window.location.search)
        query.delete(PARAM_KEY)
        query.set("page", String(page))
        // Speed: fetch only the grid section (smaller payload than full page HTML).
        try {
          const sectionId =
            document.getElementById("product-grid")?.dataset?.id || ""
          if (sectionId) query.set("section_id", sectionId)
        } catch (_) {}
        let url = `${baseUrl}?${query.toString()}`
        try {
          url = new URL(url, window.location.origin).toString()
        } catch (_) {}

        const res = await fetch(url, { credentials: "same-origin" })
        if (!res.ok) return 0
        const html = await res.text()
        const tmp = new DOMParser().parseFromString(html, "text/html")

        const gridWrapper =
          tmp.querySelector("#product-grid") ||
          tmp.querySelector("#ProductGridContainer #product-grid") ||
          tmp.querySelector("#ProductGridContainer")
        if (!gridWrapper) return 0

        const newItems = Array.from(
          gridWrapper.querySelectorAll(
            "li.grid__item:not(.daily-deals-injected)",
          ),
        )
        if (!newItems.length) return 0

        const grid = getGridEl()
        if (!grid) return 0

        if (token !== loadAllToken) return 0
        if (getSelectedMinRating() == null) return 0

        newItems.forEach((item) => {
          try {
            item.setAttribute(APPENDED_ATTR, "true")
          } catch (_) {}
          grid.appendChild(item)
        })

        document.dispatchEvent(
          new Event("more:products:loaded", { bubbles: true, composed: true }),
        )

        return newItems.length
      } catch (_) {
        return 0
      }
    }

    let loadAllInFlight = false
    let loadAllToken = 0
    let loadAllInFlightToken = 0
    let loadAllLastKey = ""
    let loadAllAppendedPages = new Set()

    async function ensureAllProductsLoadedForRatingFilter() {
      if (getSelectedMinRating() == null) return
      if (!shouldLoadAllProductsForRatingFilter()) return

      const key = getPageKeyWithoutPageParam()
      if (key !== loadAllLastKey) {
        // New server query (sort/filter changed): cancel any in-flight pagination and restart clean.
        loadAllLastKey = key
        loadAllAppendedPages = new Set()
        loadAllToken += 1
        loadAllInFlight = false
        loadAllInFlightToken = 0
      }

      if (loadAllInFlight) return

      captureOriginalTotal()
      const targetTotal = getTargetTotalCount()
      if (!targetTotal) return

      const loaded = getLoadedProductCount()
      if (loaded >= targetTotal) return

      loadAllToken += 1
      const token = loadAllToken
      loadAllInFlight = true
      loadAllInFlightToken = token

      try {
        let safety = 0
        while (safety < 20) {
          safety += 1
          if (token !== loadAllToken) break
          if (getSelectedMinRating() == null) break

          if (getLoadedProductCount() >= targetTotal) break

          const perPage = getPerPageCount()
          const computedNextPage =
            Math.ceil(getLoadedProductCount() / perPage) + 1
          const nextPage = Math.max(2, computedNextPage)

          if (loadAllAppendedPages.has(nextPage)) break
          loadAllAppendedPages.add(nextPage)

          const added = await appendPageProducts(nextPage, token)
          if (!added) break

          // Give Yotpo/footer enhancer a beat to initialize on the new cards
          await new Promise((r) => setTimeout(r, 40))
        }
      } finally {
        if (loadAllInFlightToken === token) {
          loadAllInFlight = false
          loadAllInFlightToken = 0
        }
      }
    }

    function updateTopProductCountUIForNonRating() {
      if (getSelectedMinRating() != null) return
      // Restore server-rendered ProductCount (ignoring client-only rating filter).
      try {
        const serverText = (window.__serverProductCountText || "").trim()
        const serverDesktopText = (
          window.__serverProductCountDesktopText ||
          window.__serverProductCountText ||
          ""
        ).trim()
        if (serverText) {
          const el = document.querySelector("#ProductCount")
          if (el) el.textContent = serverText
        }
        if (serverDesktopText) {
          const el = document.querySelector("#ProductCountDesktop")
          if (el) el.textContent = serverDesktopText
        }
      } catch (_) {}
    }

    function applyOrClear() {
      syncPillUI()
      if (getSelectedMinRating() == null) {
        restoreNonRatingOptionsHiddenByRating()
        setRatingFilterLoading(false)
        removeRatingAppendedProducts()
        clearRatingFilter()
        disconnectGridObserver()
        stopApplyCycle()
        loadAllToken += 1
        loadAllInFlight = false
        loadAllInFlightToken = 0
        loadAllAppendedPages = new Set()
        // Restore load-more UI (server-side pagination) when rating filter is not active
        const loadMorePart = document.querySelector(".load-more-part")
        if (loadMorePart) loadMorePart.style.display = ""
        // Top count should reflect currently shown (first page) products, not total.
        setTimeout(updateTopProductCountUIForNonRating, 0)
        setTimeout(() => {
          try {
            syncLoadMoreUI()
          } catch (_) {}
        }, 0)
        return
      }
      setRatingFilterLoading(true)
      captureOriginalTotal()
      ensureGridObserver()
      ensureAllProductsLoadedForRatingFilter()
      requestApplyCycle()
    }

    let gridObserver = null
    let observedGridEl = null
    let observerApplyTimer = null

    function disconnectGridObserver() {
      if (gridObserver) gridObserver.disconnect()
      gridObserver = null
      observedGridEl = null
      if (observerApplyTimer) clearTimeout(observerApplyTimer)
      observerApplyTimer = null
    }

    function scheduleApplyFromObserver() {
      if (observerApplyTimer) return
      observerApplyTimer = setTimeout(() => {
        observerApplyTimer = null
        if (getSelectedMinRating() == null) return
        requestApplyCycle()
      }, 150)
    }

    function ensureGridObserver() {
      const grid = getGridEl()
      if (!grid) {
        // Grid can be replaced during AJAX; retry shortly.
        setTimeout(ensureGridObserver, 250)
        return
      }

      if (gridObserver && observedGridEl === grid) return
      disconnectGridObserver()
      observedGridEl = grid

      gridObserver = new MutationObserver((mutations) => {
        if (getSelectedMinRating() == null) return
        let hit = false
        for (const m of mutations) {
          if (m.type === "childList") {
            for (const node of m.addedNodes || []) {
              if (!(node instanceof HTMLElement)) continue
              if (
                node.matches?.(".custom-yotpo-rating-number") ||
                node.querySelector?.(".custom-yotpo-rating-number")
              ) {
                hit = true
                break
              }
              if (
                node.matches?.(".yotpo-widget-instance") ||
                node.querySelector?.(".yotpo-widget-instance")
              ) {
                hit = true
              }
            }
          }
          if (hit) break
        }
        if (hit) scheduleApplyFromObserver()
      })

      gridObserver.observe(grid, { childList: true, subtree: true })
    }

    function updateTopProductCountUI() {
      const grid =
        document.querySelector("#product-grid") ||
        document.querySelector("#ProductGridContainer")
      if (!grid) return
      const visible = grid.querySelectorAll(
        "li.grid__item:not(.daily-deals-injected):not(.yotpo-rating-filter-hidden)",
      ).length
      const total = getTotalProductCount()
      setProductCountText(visible, total || visible)
    }

    function setLoadMoreVisibilityForRatingFilter() {
      // When the rating filter is active AND we have loaded all server results into the DOM,
      // the server-side paginate.next can be misleading. In that case, hide the load-more UI.
      const loadMorePart = document.querySelector(".load-more-part")
      if (!loadMorePart) return

      if (shouldLoadAllProductsForRatingFilter()) {
        loadMorePart.style.display = "none"
      } else {
        loadMorePart.style.display = ""
      }
    }

    function syncAllCountsForRatingFilter({ isFinal = true } = {}) {
      updateLoadMoreCountUI()
      updateTopProductCountUI()
      // Keep load-more totals consistent (e.g. "7 of 54") even though we hide the control.
      try {
        const total = getTotalProductCount()
        const totalElem = document.querySelector(".custom-total-product")
        if (totalElem && total) totalElem.textContent = String(total)
      } catch (_) {}
      setLoadMoreVisibilityForRatingFilter()
      setRatingFilterLoading(false)
      if (isFinal) {
        scheduleSyncNonRatingQuickFiltersUnderRating({ immediate: true })
        // Notify other scripts (e.g. daily-deals banner injector) that rating-filter visibility is final.
        try {
          document.dispatchEvent(
            new CustomEvent("yotpo:rating-filter:applied", {
              detail: { min: getSelectedMinRating() },
            }),
          )
        } catch (_) {}
      }
    }

    function bind() {
      // Initialize from URL state
      captureServerTotalFromDomIfMissing()
      // Capture the server-rendered ProductCount text (ignoring client-only rating filter)
      // so we can restore it when rating filter is cleared without a network fetch.
      try {
        if (!window.__serverProductCountText) {
          const txt = document.querySelector("#ProductCount")?.textContent || ""
          if (txt && txt.trim()) window.__serverProductCountText = txt.trim()
        }
        if (!window.__serverProductCountDesktopText) {
          const txt =
            document.querySelector("#ProductCountDesktop")?.textContent ||
            window.__serverProductCountText ||
            ""
          if (txt && txt.trim())
            window.__serverProductCountDesktopText = txt.trim()
        }
      } catch (_) {}
      applyOrClear()
      updateRatingPillVisibility()
      scheduleSyncNonRatingQuickFiltersUnderRating({ immediate: true })
      if (getSelectedMinRating() != null) {
        ensureGridObserver()
      } else {
        disconnectGridObserver()
        setTimeout(updateTopProductCountUIForNonRating, 0)
      }

      // Re-apply after quick filters / facets / load-more update the grid
      document.addEventListener("filter:applied", () => {
        applyOrClear()
        updateRatingPillVisibility()
        scheduleSyncNonRatingQuickFiltersUnderRating({ immediate: true })
      })
      document.addEventListener("more:products:loaded", () => {
        applyOrClear()
        updateRatingPillVisibility()
        scheduleSyncNonRatingQuickFiltersUnderRating({ immediate: true })
        if (getSelectedMinRating() == null) {
          setTimeout(updateTopProductCountUIForNonRating, 0)
        }
      })
      // Swatch changes refresh the Yotpo widget; re-apply the rating rule afterwards.
      document.addEventListener("yotpo:card:refresh", () => {
        setTimeout(() => {
          applyOrClear()
          updateRatingPillVisibility()
          scheduleSyncNonRatingQuickFiltersUnderRating({ immediate: true })
        }, 0)
      })
      // Back/forward navigation should also re-apply
      window.addEventListener("popstate", () => {
        applyOrClear()
        updateRatingPillVisibility()
        scheduleSyncNonRatingQuickFiltersUnderRating({ immediate: true })
        if (getSelectedMinRating() == null) {
          setTimeout(updateTopProductCountUIForNonRating, 0)
        }
      })
    }

    // Pills are rendered by Liquid; bind after DOM is ready and also after re-renders.
    document.addEventListener("DOMContentLoaded", bind)
    document.addEventListener("shopify:section:load", bind)
  })()

  // ============================================================================
  // PLP Rating dropdown (Top Rated – mirrors Gift Center price/rating dropdown)
  // ============================================================================
  ;(function initPlpRatingDropdown() {
    if (window.__plpRatingDropdownInitialized) return
    window.__plpRatingDropdownInitialized = true

    const PARAM_KEY = "yotpo_rating_min"

    function getWrap() {
      return document.querySelector("[data-plp-rating-wrap]")
    }

    function getSelectedMinFromUrl() {
      try {
        return (
          new URLSearchParams(window.location.search).get(PARAM_KEY) || ""
        ).trim()
      } catch (_) {
        return ""
      }
    }

    function parseRating(val) {
      const v = parseFloat(String(val || "").trim())
      return Number.isFinite(v) ? v : null
    }

    let _cachedPlpRatingDefaultLabel = null
    function syncPlpRatingDropdown() {
      const wrap = getWrap()
      if (!wrap) return
      const selectedRaw = getSelectedMinFromUrl()
      const selectedNum = parseRating(selectedRaw)
      const pill = wrap.querySelector("[data-plp-rating-pill]")
      const pillLabel = wrap.querySelector("[data-plp-rating-pill-label]")
      const radios = document.querySelectorAll("[data-plp-rating-radio]")
      const labels = document.querySelectorAll(".plp-rating-label")
      if (!_cachedPlpRatingDefaultLabel) {
        _cachedPlpRatingDefaultLabel =
          (wrap.dataset.ratingDefaultLabel || "").trim() ||
          (pillLabel?.textContent || "").trim() ||
          "Top Rated"
      }
      const defaultLabel = _cachedPlpRatingDefaultLabel

      labels.forEach((l) => l.classList.remove("active"))
      let selectedVal = null
      radios.forEach((radio) => {
        const val = (radio.value || "").trim()
        const valNum = parseRating(val)
        const isChecked =
          selectedNum != null &&
          valNum != null &&
          Math.abs(selectedNum - valNum) < 0.001
        radio.checked = isChecked
        if (isChecked) {
          radio.closest(".plp-rating-label")?.classList.add("active")
          selectedVal = val
        }
      })
      if (pill) {
        pill.classList.toggle("selected", selectedNum != null)
        pill.setAttribute(
          "aria-expanded",
          wrap.querySelector("[data-plp-rating-details]")?.open ?? false,
        )
      }
      if (pillLabel) {
        pillLabel.textContent = selectedVal
          ? `${selectedVal}+ Rating`
          : defaultLabel
      }
      syncPlpRatingAriaSelected(wrap)
    }

    function getVisiblePlpRatingOptions() {
      return Array.from(
        document.querySelectorAll("[data-plp-rating-item]"),
      ).filter((li) => li.style.display !== "none")
    }

    function announcePlpRatingSelection(wrap, text) {
      const liveEl = document.querySelector("[data-plp-rating-live]")
      if (!liveEl) return
      liveEl.textContent = ""
      requestAnimationFrame(() => {
        liveEl.textContent = text
      })
    }

    function syncPlpRatingAriaSelected(wrap) {
      const selectedNum = parseRating(getSelectedMinFromUrl())
      document.querySelectorAll("[data-plp-rating-item]").forEach((li) => {
        const threshold = parseRating(li.getAttribute("data-rating-threshold"))
        const isSelected =
          selectedNum != null &&
          threshold != null &&
          Math.abs(selectedNum - threshold) < 0.001
        li.setAttribute("aria-selected", isSelected ? "true" : "false")
      })
    }

    function bindPlpRatingDropdown() {
      const wrap = getWrap()
      if (!wrap) return
      const details = wrap.querySelector("[data-plp-rating-details]")
      const pill = wrap.querySelector("[data-plp-rating-pill]")
      const dropdown = wrap.querySelector(".plp-rating-dropdown")
      const radios = wrap.querySelectorAll("[data-plp-rating-radio]")

      function selectPlpRatingValue(val) {
        const url = new URL(window.location.href)
        if (val) {
          url.searchParams.set(PARAM_KEY, val)
        } else {
          url.searchParams.delete(PARAM_KEY)
        }
        url.searchParams.delete("page")
        history.replaceState({}, "", url.toString())
        syncPlpRatingDropdown()
        syncPlpRatingAriaSelected(wrap)
        updatePlpRatingDropdownVisibility()
        const textEl = val
          ? wrap.querySelector(
              `[data-rating-value="${val}"] .plp-rating-option-text`,
            )
          : null
        announcePlpRatingSelection(
          wrap,
          textEl
            ? `Selected: ${textEl.textContent.trim()}`
            : "Rating filter cleared",
        )
        document.dispatchEvent(
          new CustomEvent("filter:applied", {
            detail: { key: PARAM_KEY, value: val || null },
          }),
        )
      }

      radios.forEach((radio) => {
        radio.addEventListener("change", () => {
          const val = (radio.value || "").trim()
          selectPlpRatingValue(val)
        })
      })

      function closeDropdown() {
        if (details.open) {
          details.removeAttribute("open")
          pill.focus()
        }
      }

      function focusOption(optionLi) {
        if (!optionLi) return
        optionLi.focus()
        if (dropdown) {
          dropdown.setAttribute("aria-activedescendant", optionLi.id || "")
        }
      }

      function handlePlpRatingKeydown(e) {
        if (!details.open) return
        const visibleOptions = getVisiblePlpRatingOptions()
        if (!visibleOptions.length) return
        const currentFocused = document.activeElement?.closest(
          "[data-plp-rating-item]",
        )
        const currentIdx = currentFocused
          ? visibleOptions.indexOf(currentFocused)
          : -1

        switch (e.key) {
          case "ArrowDown": {
            e.preventDefault()
            const nextIdx =
              currentIdx < visibleOptions.length - 1 ? currentIdx + 1 : 0
            focusOption(visibleOptions[nextIdx])
            break
          }
          case "ArrowUp": {
            e.preventDefault()
            const prevIdx =
              currentIdx > 0 ? currentIdx - 1 : visibleOptions.length - 1
            focusOption(visibleOptions[prevIdx])
            break
          }
          case "Home": {
            e.preventDefault()
            focusOption(visibleOptions[0])
            break
          }
          case "End": {
            e.preventDefault()
            focusOption(visibleOptions[visibleOptions.length - 1])
            break
          }
          case "Enter":
          case " ": {
            e.preventDefault()
            if (currentFocused) {
              const radio = currentFocused.querySelector(
                "[data-plp-rating-radio]",
              )
              if (radio) {
                radio.checked = true
                selectPlpRatingValue((radio.value || "").trim())
              }
            }
            closeDropdown()
            break
          }
          case "Escape":
          case "Tab": {
            closeDropdown()
            break
          }
        }
      }
      wrap.addEventListener("keydown", handlePlpRatingKeydown)
      if (dropdown) dropdown.addEventListener("keydown", handlePlpRatingKeydown)

      if (details && pill) {
        const plpDropdownParent = dropdown?.parentNode

        let touchedPlpRating = false
        pill.addEventListener("touchend", (e) => {
          e.preventDefault()
          touchedPlpRating = true
          details.open = !details.open
        })
        pill.addEventListener("click", (e) => {
          e.preventDefault()
          if (touchedPlpRating) {
            touchedPlpRating = false
            return
          }
          details.open = !details.open
        })

        function positionDropdown() {
          if (!details.open || !pill || !dropdown) return
          const rect = pill.getBoundingClientRect()
          dropdown.style.left = `${rect.left}px`
          dropdown.style.top = `${rect.bottom + 8}px`
        }
        details.addEventListener("toggle", () => {
          pill.setAttribute("aria-expanded", details.open)
          if (details.open) {
            if (dropdown) {
              document.body.appendChild(dropdown)
              dropdown.style.display = "block"
            }
            positionDropdown()
            try {
              updatePlpRatingDropdownVisibility()
              syncPlpRatingAriaSelected(wrap)
            } catch (_) {}
            window.addEventListener("scroll", positionDropdown, true)
            window.addEventListener("resize", positionDropdown)
            requestAnimationFrame(() => {
              try {
                updatePlpRatingDropdownVisibility()
              } catch (_) {}
              positionDropdown()
              const visibleOptions = getVisiblePlpRatingOptions()
              const selected = visibleOptions.find(
                (li) => li.getAttribute("aria-selected") === "true",
              )
              focusOption(selected || visibleOptions[0])
            })
          } else {
            if (dropdown) {
              dropdown.style.display = "none"
              plpDropdownParent?.appendChild(dropdown)
            }
            window.removeEventListener("scroll", positionDropdown, true)
            window.removeEventListener("resize", positionDropdown)
          }
        })
        document.addEventListener("click", (e) => {
          if (!details.open) return
          if (!wrap.contains(e.target) && !dropdown?.contains(e.target)) {
            details.removeAttribute("open")
          }
        })
      }
    }

    let plpRatingVisRetryCount = 0

    function parsePlpAriaRating(widget) {
      if (!widget) return null
      const labelEl =
        widget.querySelector(".yotpo-sr-bottom-line-summary [aria-label]") ||
        widget.querySelector('[aria-label*="out"]') ||
        widget.querySelector("[aria-label]")
      const label = labelEl?.getAttribute?.("aria-label") || ""
      const tokens = []
      const re = /(\d+(?:[.,]\d+)?)/g
      let m
      while ((m = re.exec(label))) {
        const n = parseFloat(m[1].replace(",", "."))
        if (!Number.isFinite(n)) continue
        tokens.push(n)
      }
      if (!tokens.length) return null
      const scaleIdx = tokens.findIndex((t) => Math.abs(t - 5) < 0.0001)
      const candidate = scaleIdx > 0 ? tokens[scaleIdx - 1] : tokens[0]
      if (candidate == null || candidate < 0 || candidate > 5) return null
      return candidate
    }

    /**
     * Best-known rating for one PLP card using the same priority as the filter.
     * Uses data-yotpo-score (rounded to 1 decimal in Liquid) first, then the
     * displayed number, then aria-label, then swatch cache — returning the first
     * match instead of taking the max of all sources. This keeps dropdown options
     * aligned with what the user actually sees on the card.
     */
    function getPlpItemMaxAndPending(li, cache) {
      const widget = li.querySelector(".yotpo-widget-instance")
      if (!widget) {
        return { pending: false, max: 0 }
      }

      const ready = widget.classList.contains("yotpo-card-ready")
      const suppressed =
        ready && widget.classList.contains("yotpo-card-suppressed")
      if (suppressed) {
        return { pending: false, max: 0 }
      }

      const metaScore = parseFloat(
        (widget.getAttribute("data-yotpo-score") || "").trim(),
      )
      if (Number.isFinite(metaScore) && metaScore > 0) {
        return { pending: false, max: metaScore }
      }

      const numEl = li.querySelector(
        ".yotpo-widget-instance .custom-yotpo-rating-number",
      )
      if (numEl) {
        const displayed = parseFloat((numEl.textContent || "").trim())
        if (Number.isFinite(displayed) && displayed > 0) {
          return { pending: false, max: displayed }
        }
      }

      const ariaRating = parsePlpAriaRating(widget)
      if (Number.isFinite(ariaRating) && ariaRating > 0) {
        return { pending: false, max: ariaRating }
      }

      let swatchMax = 0
      Array.from(
        li.querySelectorAll(".custom-swatches-check[data-yotpo-product-id]"),
      ).forEach((input) => {
        const sid = (input.getAttribute("data-yotpo-product-id") || "").trim()
        if (sid && typeof cache[sid] === "number")
          swatchMax = Math.max(swatchMax, cache[sid])
      })
      if (swatchMax > 0) {
        return { pending: false, max: swatchMax }
      }

      const pending = !ready && !suppressed
      return { pending, max: 0 }
    }

    function updatePlpRatingDropdownVisibility() {
      const wrap = getWrap()
      if (!wrap) return

      const grid =
        document.getElementById("product-grid") ||
        document.querySelector("#ProductGridContainer #product-grid")
      if (!grid) return

      const YOTPO_RATING_CACHE_KEY = "__yotpoRatingCache"
      const cache =
        window[YOTPO_RATING_CACHE_KEY] || (window[YOTPO_RATING_CACHE_KEY] = {})

      const items = Array.from(
        grid.querySelectorAll("li.grid__item:not(.daily-deals-injected)"),
      )
      const ratingOptions = document.querySelectorAll("[data-plp-rating-item]")

      let globalPending = false
      let pageMax = 0
      for (const li of items) {
        const st = getPlpItemMaxAndPending(li, cache)
        if (st.pending) globalPending = true
        pageMax = Math.max(pageMax, st.max)
      }

      const currentMin = parseRating(getSelectedMinFromUrl())
      let anyOptionVisible = false

      ratingOptions.forEach((optionLi) => {
        const threshold = parseRating(
          optionLi.getAttribute("data-rating-threshold"),
        )
        if (threshold == null) return

        const isSelected =
          currentMin != null && Math.abs(currentMin - threshold) < 0.001
        if (isSelected) {
          optionLi.style.display = ""
          anyOptionVisible = true
          return
        }

        if (globalPending && pageMax === 0) {
          optionLi.style.display = ""
          anyOptionVisible = true
          return
        }

        if (pageMax + 1e-9 >= threshold) {
          optionLi.style.display = ""
          anyOptionVisible = true
        } else {
          optionLi.style.display = "none"
        }
      })

      wrap.style.display = anyOptionVisible ? "" : "none"

      if (globalPending && plpRatingVisRetryCount < 20) {
        plpRatingVisRetryCount += 1
        setTimeout(updatePlpRatingDropdownVisibility, 400)
      } else {
        plpRatingVisRetryCount = 0
      }
    }

    function bindPlp() {
      bindPlpRatingDropdown()
      syncPlpRatingDropdown()
      updatePlpRatingDropdownVisibility()

      document.addEventListener("filter:applied", () => {
        syncPlpRatingDropdown()
        updatePlpRatingDropdownVisibility()
      })
      document.addEventListener("more:products:loaded", () => {
        updatePlpRatingDropdownVisibility()
      })
      document.addEventListener("yotpo:card:refresh", () => {
        setTimeout(() => {
          updatePlpRatingDropdownVisibility()
        }, 0)
      })
      window.addEventListener("popstate", () => {
        syncPlpRatingDropdown()
        updatePlpRatingDropdownVisibility()
      })
    }

    document.addEventListener("DOMContentLoaded", bindPlp)
    document.addEventListener("shopify:section:load", bindPlp)
  })()

  function parsePositiveInt(text) {
    const n = parseInt(String(text || "").replace(/[^\d]/g, ""), 10)
    return Number.isFinite(n) && n >= 0 ? n : 0
  }

  function isRatingMinActive() {
    try {
      return !!(
        new URLSearchParams(window.location.search).get("yotpo_rating_min") ||
        ""
      ).trim()
    } catch (_) {
      return false
    }
  }

  function syncLoadMoreUI() {
    const loadMorePart = document.querySelector(".load-more-part")
    if (!loadMorePart) return

    const grid =
      document.querySelector("#product-grid") ||
      document.querySelector("#ProductGridContainer")
    if (!grid) return

    const ratingActive = isRatingMinActive()
    const loadAllForRating =
      window.__yotpoRatingLoadAllProducts === true ||
      (window.__yotpoRatingLoadAllProducts !== false && ratingActive)

    const loadedCount = grid.querySelectorAll(
      "li.grid__item:not(.daily-deals-injected)",
    ).length
    const visibleCount = ratingActive
      ? grid.querySelectorAll(
          "li.grid__item:not(.daily-deals-injected):not(.yotpo-rating-filter-hidden)",
        ).length
      : loadedCount

    const shownEl = loadMorePart.querySelector(".custom-show-product")
    const totalEl = loadMorePart.querySelector(".custom-total-product")
    const progress = loadMorePart.querySelector(".load-more-progress-bar")
    const btn = loadMorePart.querySelector(".load-more-btn")
    const loadMoreWrap = loadMorePart.querySelector(".load-more")

    if (shownEl) shownEl.textContent = String(visibleCount)

    if (ratingActive && loadAllForRating) {
      loadMorePart.style.display = "none"
      return
    }
    // Rating filter (fast mode): keep load-more enabled so users can page through products.
    if (ratingActive && !loadAllForRating) loadMorePart.style.display = ""

    // Non-rating: never allow "shown > total". If the server total is missing or smaller than shown,
    // treat it as "no more pages" and clamp total to shown.
    if (totalEl) {
      const total = parsePositiveInt(totalEl.textContent)
      const clampedTotal = total && total >= loadedCount ? total : loadedCount
      totalEl.textContent = String(clampedTotal)
      if (progress) {
        progress.style.width = clampedTotal
          ? `${Math.min(100, (loadedCount / clampedTotal) * 100)}%`
          : "0%"
      }
      // If we're already at/over total, hide the Show more button.
      if (clampedTotal <= loadedCount) {
        if (btn) btn.classList.add("hidden")
        if (loadMoreWrap) loadMoreWrap.style.display = "none"
      } else {
        if (btn) btn.classList.remove("hidden")
        if (loadMoreWrap) loadMoreWrap.style.display = ""
      }
    }
  }

  // Normalizes a filter value for comparison (strips special chars, lowercases, trims)
  function normalizeFilterValue(val) {
    if (typeof val !== "string") return ""
    return val
      .replace(/\+/g, " ")
      .replace(/%20/g, " ")
      .replace(/[^a-zA-Z0-9 ]+/g, "")
      .toLowerCase()
      .trim()
  }
  // Checks if the given filter value matches any quick filter pill in the DOM
  function isQuickFilterMatch(filterValue) {
    const normalized = filterValue.trim().toLowerCase()
    const quickFilterSpans = document.querySelectorAll(".quick-filter-pill")
    for (const span of quickFilterSpans) {
      const label = span.textContent.trim().toLowerCase()
      const dataVal = span
        .getAttribute("data-p")
        ?.split("|")[1]
        ?.trim()
        .toLowerCase()
      if (normalized === label || normalized === dataVal) {
        return true
      }
    }
    return false
  }
  // Creates and appends a quick filter pill to the container, if not already present
  function createQuickFilterPill(
    type,
    value,
    label,
    isMostPopular = false,
    isQuickFilter = false,
    isQuickFilterMatch = true,
  ) {
    if (isMostPopular) return
    const container = document.querySelector(".quick-filters-container")
    if (!container) return
    const existing = container.querySelector(`[data-${type}="${value}"]`)
    if (existing) return
    const pillElement = document.createElement("span")
    pillElement.className = "quick-filter-pill"
    pillElement.setAttribute(`data-${type}`, value)
    pillElement.textContent = label
    if (!pillElement || !(pillElement instanceof Node) || !container) return
    if (pillElement && container) {
      container.appendChild(pillElement)
    }
  }
  // Prevent pill flicker: lock rendering for 200ms after quick filter click
  window.justClickedQuickFilter = false
  window.justClickedQuickFilterTimestamp = null
  // ============================================================================
  // Pill Logic, Event Bindings, AJAX/Product Grid Updates, Drawer Sync, Show More
  // ============================================================================

  // Helper: Scroll quick-filter-main to the leftmost pill
  function scrollQuickFilterMainLeft() {
    const quickFilterMain = document.querySelector(".quick-filter-main")
    if (
      window.preventNextQuickFilterScroll ||
      !quickFilterMain ||
      quickFilterMain.offsetParent === null ||
      quickFilterMain.offsetWidth === 0 ||
      quickFilterMain.offsetHeight === 0
    ) {
      window.preventNextQuickFilterScroll = false
      return
    }
    requestAnimationFrame(() => {
      const mobileGutter = getMobileGutterPx()
      scrollLeftCompat(quickFilterMain, true, mobileGutter)
    })
    window.preventNextQuickFilterScroll = false
  }

  // Mobile breakpoint helper (< 767px)
  function isMobile() {
    try {
      return (
        window.matchMedia && window.matchMedia("(max-width: 767px)").matches
      )
    } catch (_) {
      return (window.innerWidth || 0) < 767
    }
  }

  // Platform helper: Android devices
  function isAndroid() {
    try {
      const ua = navigator.userAgent || ""
      return /Android/i.test(ua)
    } catch (_) {
      return false
    }
  }

  // For left-snap after any filter action on mobile, we rely on CSS padding-left
  // so the correct scrollLeft target is 0 (not the padding value).
  function getMobileGutterPx() {
    if (!isMobile()) return 0
    return 0
  }

  // Ensures the hidden spacer at the start of the pill row keeps the mobile gutter width
  function updateQuickFilterSpacer(spacer, { forceCollapse = false } = {}) {
    if (!spacer) return

    // Hide the spacer entirely when it should not contribute to layout
    if (
      !isMobile() ||
      forceCollapse ||
      window.__applyGutterSpacerNow === false
    ) {
      spacer.style.display = "none"
      spacer.style.width = "0px"
      return
    }

    // Keep spacer collapsed so CSS padding controls the visual gutter
    spacer.style.display = "none"
    spacer.style.width = "0px"
    spacer.style.flexShrink = "0"
  }

  // Main entry point: handles pill logic, event bindings, AJAX loading, drawer sync, and show more
  document.addEventListener("DOMContentLoaded", () => {
    // Make functions globally accessible immediately
    if (typeof getFilters === "function") {
      window.getFilters = getFilters
    }
    if (typeof loadContent === "function") {
      window.loadContent = loadContent
    }
    if (typeof renderFilters === "function") {
      window.renderFilters = renderFilters
    }
    if (typeof toggleClearFiltersVisibility === "function") {
      window.toggleClearFiltersVisibility = toggleClearFiltersVisibility
    }
    if (typeof scrollQuickFilterMainLeft === "function") {
      window.scrollQuickFilterMainLeft = scrollQuickFilterMainLeft
    }
    if (typeof resetAllFiltersAndReload === "function") {
      window.resetAllFiltersAndReload = resetAllFiltersAndReload
    }
    if (typeof adjustQuickFilterMainGap === "function") {
      window.adjustQuickFilterMainGap = adjustQuickFilterMainGap
    }

    // --- [PillCreate] Function to inject unmatched "Most Popular" pills from URL ---
    // Normalizes the label for "Most Popular" filters for comparison
    function normalizeMostPopular(val) {
      return decodeURIComponent(val || "")
        .replace(/\+/g, " ")
        .replace(/%20/g, " ")
        .replace(/\s+/g, " ")
        .replace(/[^a-z0-9 ]+/gi, "")
        .toLowerCase()
        .trim()
    }
    // Injects unmatched "Most Popular" pills from the URL that are checked in the drawer but not present as quick filter buttons
    function createUnmatchedMostPopularPills() {
      // Only run this logic for the "most_popular" filter context
      const params = new URLSearchParams(window.location.search)
      const activeMostPopularFilters =
        params.getAll("filter.p.m.custom.most_popular") || []
      const pillsContainer = document.querySelector(".quick-filters-container")
      if (!pillsContainer) return

      function normalizeMostPopular(val) {
        return decodeURIComponent(val || "")
          .replace(/\+/g, " ")
          .replace(/%20/g, " ")
          .replace(/\s+/g, " ")
          .replace(/[^a-z0-9 ]+/gi, "")
          .toLowerCase()
          .trim()
      }

      activeMostPopularFilters.forEach((label) => {
        if (!label) return
        // Compare filter param values, not just label/text, for language-agnostic deduplication
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return (
            btnVal && btnVal.trim().toLowerCase() === label.trim().toLowerCase()
          )
        })
        if (quickBtn && quickBtn.classList.contains("selected")) {
          return
        }
        // Only show pill if option is checked in drawer
        const drawerCheckbox = Array.from(
          document.querySelectorAll(
            'input[name="filter.p.m.custom.most_popular"]',
          ),
        ).find(
          (input) =>
            decodeURIComponent(input.value).trim().toLowerCase() ===
            label.trim().toLowerCase(),
        )
        if (!drawerCheckbox || !drawerCheckbox.checked) return

        // Only create pill if NOT already present (prevents duplication)
        const pillExists = Array.from(
          pillsContainer.querySelectorAll(
            '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
          ),
        ).some(
          (pill) =>
            (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
              .trim()
              .toLowerCase() === label.trim().toLowerCase(),
        )
        if (pillExists) return

        // Otherwise, create the pill
        const pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = label
        pill.dataset.p = `filter.p.m.custom.most_popular|${label}`

        pill.addEventListener("click", function () {
          const param = pill.getAttribute("data-p")
          if (param) {
            const [name, value] = param.split("|")
            const urlParams = new URLSearchParams(window.location.search)
            const values = urlParams.getAll(name)
            const newValues = values.filter((v) => v !== value)
            urlParams.delete(name)
            newValues.forEach((v) => urlParams.append(name, v))
            history.replaceState(
              {},
              "",
              `${window.location.pathname}?${urlParams}`,
            )
            if (typeof loadContent2 === "function") {
              loadContent2(
                window.location.pathname + "?" + urlParams.toString(),
              )
            }
          }
        })

        if (pill && pillsContainer) {
          // Insert after the gutter spacer, if present
          const spacer = pillsContainer.querySelector(
            ".quick-filter-gutter-spacer",
          )
          if (spacer && spacer.parentNode === pillsContainer) {
            pillsContainer.insertBefore(pill, spacer.nextSibling)
          } else {
            pillsContainer.insertBefore(pill, pillsContainer.firstChild)
          }
        }
      })
    }
    // [QuickScroll] Setup quick filter pill click handler to set skipScrollBecauseOfQuickFilterClick
    document.querySelectorAll(".quick-filter-pill").forEach((pill) => {
      pill.addEventListener("click", () => {
        skipScrollBecauseOfQuickFilterClick = true
        setTimeout(() => {
          skipScrollBecauseOfQuickFilterClick = false
        }, 1500)
      })
    })
    const quickWrapper = document.querySelector(".quick-filter-main")
    if (!quickWrapper) return

    const drawerSelector = "#FacetFiltersFormMobile, #FacetFiltersForm"
    let drawerForm = document.querySelector(drawerSelector)
    const currency = Shopify.currency?.symbol || "$"
    let userSelectedSort = false
    let userManuallySorted = false

    // Make variables globally accessible for functions outside this scope
    window.userSelectedSort = userSelectedSort
    window.userManuallySorted = userManuallySorted

    const quickContainer = document.createElement("div")
    quickContainer.className = "quick-filters-container"
    // Always append quickContainer safely at the leftmost position
    if (quickWrapper && quickContainer instanceof HTMLElement) {
      quickWrapper.appendChild(quickContainer)
      // Ensure a stable left gutter spacer exists (but keep width 0px on all add/remove per latest request)
      const ensureGutterSpacer = () => {
        try {
          if (!isMobile()) return
          if (!quickContainer.querySelector(".quick-filter-gutter-spacer")) {
            const spacer = document.createElement("span")
            spacer.className = "quick-filter-gutter-spacer"
            spacer.style.flexShrink = "0"
            quickContainer.insertBefore(spacer, quickContainer.firstChild)
            updateQuickFilterSpacer(spacer)
          } else {
            updateQuickFilterSpacer(
              quickContainer.querySelector(".quick-filter-gutter-spacer"),
            )
          }
        } catch (_) {}
      }
      ensureGutterSpacer()
    }

    // --- [REMOVED] Ensure quick filters container uses flex layout and order property ---
    // The pill order is controlled entirely by the JS array (pillOrderArr) and insertion point,
    // not by CSS flex-direction or order. All pills are inserted using
    // quickContainer.insertBefore(pill, quickContainer.firstChild), so the newest pill appears leftmost.

    const clearFilters =
      document.querySelector(".active-facets__button-remove").textContent ||
      "Clear Filters"
    const clearAllBtn = document.createElement("button")
    clearAllBtn.textContent = clearFilters
    clearAllBtn.className =
      "quick-filter-clear-all quick-filter-clear-all-desktop btn-collection-filter button button--tertiary"
    clearAllBtn.style.display = "none"
    quickWrapper.appendChild(clearAllBtn)

    const drawerDetails = document.querySelector(".mobile-facets__disclosure")

    if (drawerDetails) {
      drawerDetails.addEventListener("toggle", () => {
        if (drawerDetails.open) {
          // Reopen all inner <details> inside drawer
          drawerDetails
            .querySelectorAll(".mobile-facets__details")
            .forEach((section) => {
              section.open = true
            })
        }
      })
    }

    // Utility: Debounces a function call (delays execution until after wait ms have elapsed)
    function debounce(func, wait = 300) {
      let timeout
      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(this, args), wait)
      }
    }

    // Extracts all filter values from both desktop and mobile forms into an object
    function getFilters() {
      const filters = {}
      const forms = [
        document.querySelector("#FacetFiltersForm"),
        document.querySelector("#FacetFiltersFormMobile"),
      ]

      forms.forEach((form) => {
        if (!form) return

        const data = new FormData(form)
        for (const [key, value] of data.entries()) {
          const trimmed = value?.toString().trim()

          if (!trimmed) continue

          const isPriceFilter =
            key === "filter.v.price.gte" || key === "filter.v.price.lte"
          if (isPriceFilter && trimmed === "") continue

          filters[key] = filters[key] || []
          filters[key].push(trimmed)
        }
      })

      // Preserve URL-driven client-side rating filter across all other filter interactions
      try {
        const v = new URLSearchParams(window.location.search).get(
          "yotpo_rating_min",
        )
        if (v && v.toString().trim()) {
          filters["yotpo_rating_min"] = [v.toString().trim()]
        }
      } catch (_) {}

      // Remove default sort if not explicitly selected
      if (!window.userSelectedSort && filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"]
      }

      // Additional safety: remove manual sort if user hasn't explicitly selected it
      if (!window.userManuallySorted && filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if sort pill was recently removed
      if (window.__sortPillRemoved) {
        delete filters["sort_by"]
      }

      return filters
    }

    // Converts filter object into a URLSearchParams string, handling arrays and primitives
    function buildCleanParams(params = {}) {
      const cleanParams = new URLSearchParams()

      for (const [key, value] of Object.entries(params)) {
        if (
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        ) {
          cleanParams.set(key, value)
        } else if (Array.isArray(value)) {
          for (const val of value) {
            cleanParams.append(key, val)
          }
        }
      }

      return cleanParams.toString()
    }

    // Updates the URL with new filters and triggers AJAX reload of content
    async function updateURL(filters) {
      // Remove default sort unless user clicked a sort radio
      if (!window.userManuallySorted && filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if sort pill was recently removed
      if (window.__sortPillRemoved) {
        delete filters["sort_by"]
      }

      const ps = buildCleanParams(filters)
      const newUrl = ps.toString()
        ? `${window.location.pathname}?${ps}`
        : window.location.pathname
      if (filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"] // remove default unless user changed it
      }
      history.replaceState({}, "", newUrl)
      loadContent(filters)
    }

    // Extracts available "Most Popular" options from the DOM for button/pill rendering
    function extractLiveMostPopularOptionsFromDOM(container = document) {
      return Array.from(
        container.querySelectorAll(
          'input[name="filter.p.m.custom.most_popular"]',
        ),
      )
        .filter((input) => !input.disabled)
        .map((input) => decodeURIComponent(input.value?.trim() || ""))
    }

    let mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()

    let loadContentAbortController = null
    let loadContentRequestId = 0
    const FILTER_FETCH_ABORT_ENABLED = window.__facetFetchAbortEnabled === true

    function getRequestKeyForUrl(urlLike) {
      try {
        const u = new URL(urlLike, window.location.origin)
        u.searchParams.delete("page")
        u.searchParams.delete("yotpo_rating_min")
        const sorted = new URLSearchParams()
        ;[...u.searchParams.entries()]
          .sort((a, b) => {
            if (a[0] !== b[0]) return a[0].localeCompare(b[0])
            return String(a[1]).localeCompare(String(b[1]))
          })
          .forEach(([k, v]) => sorted.append(k, v))
        return `${u.pathname}?${sorted.toString()}`
      } catch (_) {
        return `${window.location.pathname}|${window.location.search}`
      }
    }

    // Initialize the last-known server query key for this page load.
    try {
      window.__lastFacetRequestKey =
        window.__lastFacetRequestKey ||
        getRequestKeyForUrl(window.location.href)
    } catch (_) {}

    // Loads filtered product grid and related UI via AJAX, replaces DOM sections, and rebinds events
    async function loadContent(filters) {
      currentPage = 1
      const requestId = (loadContentRequestId = loadContentRequestId + 1)
      try {
        if (FILTER_FETCH_ABORT_ENABLED && loadContentAbortController) {
          try {
            loadContentAbortController.abort()
          } catch (_) {}
        }
        loadContentAbortController = new AbortController()
      } catch (_) {
        loadContentAbortController = null
      }

      const hasRatingMin = (() => {
        try {
          return !!(
            new URLSearchParams(window.location.search).get(
              "yotpo_rating_min",
            ) || ""
          ).trim()
        } catch (_) {
          return false
        }
      })()
      // If the rating filter is active, block UI updates until the final filtered result is ready.
      try {
        if (typeof window.__setYotpoRatingFilterLoading === "function") {
          window.__setYotpoRatingFilterLoading(hasRatingMin)
        }
      } catch (_) {}

      try {
        // Disable all quick filter pills during loading
        document
          .querySelectorAll(".quick-filter-pill")
          .forEach((pill) => pill.classList.add("disabled"))

        // `yotpo_rating_min` is client-only; do not include it in network requests to avoid cache fragmentation.
        let cleanUrl = ""
        if (typeof filters === "string") {
          try {
            const u = new URL(filters, window.location.origin)
            u.searchParams.delete("yotpo_rating_min")
            const qs = u.searchParams.toString()
            cleanUrl = qs ? `${u.pathname}?${qs}` : u.pathname
          } catch (_) {
            cleanUrl = window.location.pathname
          }
        } else {
          const requestFilters =
            filters && typeof filters === "object" && !Array.isArray(filters)
              ? { ...filters }
              : {}
          delete requestFilters.yotpo_rating_min
          const qs = buildCleanParams(requestFilters)
          cleanUrl = qs
            ? `${window.location.pathname}?${qs}`
            : window.location.pathname
        }
        const requestKey = getRequestKeyForUrl(cleanUrl)

        // If only the client-side rating filter toggled (server query unchanged),
        // skip network and just re-run the client-side filter logic.
        if (requestKey === window.__lastFacetRequestKey) {
          document.dispatchEvent(
            new Event("filter:applied", { bubbles: true, composed: true }),
          )
          setTimeout(() => {
            try {
              syncLoadMoreUI()
            } catch (_) {}
          }, 0)
          return
        }

        const fetchOpts = {}
        if (FILTER_FETCH_ABORT_ENABLED && loadContentAbortController?.signal) {
          fetchOpts.signal = loadContentAbortController.signal
        }

        // Speed: fetch only the main collection/search grid section when possible
        // instead of the entire page HTML.
        let fetchUrl = cleanUrl
        try {
          const u = new URL(cleanUrl, window.location.origin)
          const sectionId =
            document.getElementById("product-grid")?.dataset?.id ||
            document.getElementById("main-collection-filters")?.dataset?.id ||
            ""
          if (sectionId) u.searchParams.set("section_id", sectionId)
          fetchUrl = u.toString()
        } catch (_) {}

        const res = await fetch(fetchUrl, fetchOpts)
        const html = await res.text()
        if (
          (FILTER_FETCH_ABORT_ENABLED &&
            loadContentAbortController &&
            loadContentAbortController.signal.aborted) ||
          requestId !== loadContentRequestId
        ) {
          return
        }
        const tmp = new DOMParser().parseFromString(html, "text/html")

        // Keep ProductCount text and translated templates in sync with the server response.
        // When the rating filter is active, we store the server count and let the client-side
        // rating filter override the visible count later.
        try {
          const nextTemplates = tmp.querySelector("#CollectionTrueTotal")
          const curTemplates = document.querySelector("#CollectionTrueTotal")
          if (nextTemplates && curTemplates) {
            ;[
              "data-collection-total",
              "data-collection-all-total",
              "data-product-count",
              "data-product-count-one",
              "data-product-count-other",
            ].forEach((attr) => {
              const v = nextTemplates.getAttribute(attr)
              if (typeof v === "string") curTemplates.setAttribute(attr, v)
            })
          }
        } catch (_) {}

        try {
          const nextCount =
            tmp.querySelector("#ProductCount")?.textContent || ""
          const nextCountDesktop =
            tmp.querySelector("#ProductCountDesktop")?.textContent || ""
          const serverText = nextCount.trim()
          const serverDesktopText = (nextCountDesktop || nextCount).trim()
          if (serverText) {
            window.__serverProductCountText = serverText
            window.__serverProductCountDesktopText = serverDesktopText
            if (!hasRatingMin) {
              const el = document.querySelector("#ProductCount")
              if (el) el.textContent = serverText
              const elD = document.querySelector("#ProductCountDesktop")
              if (elD) elD.textContent = serverDesktopText
            }
          }
        } catch (_) {}

        // Cache server-side total product count for this query (excluding page + client-only rating param).
        // The rating filter mutates some count UIs client-side; this keeps a stable "true total" for pagination.
        try {
          const u = new URL(cleanUrl, window.location.origin)
          u.searchParams.delete("page")
          u.searchParams.delete("yotpo_rating_min")
          const sorted = new URLSearchParams()
          ;[...u.searchParams.entries()]
            .sort((a, b) => {
              if (a[0] !== b[0]) return a[0].localeCompare(b[0])
              return String(a[1]).localeCompare(String(b[1]))
            })
            .forEach(([k, v]) => sorted.append(k, v))
          const key = `${u.pathname}?${sorted.toString()}`
          const rawTotal =
            tmp
              .querySelector("#CollectionTrueTotal")
              ?.getAttribute("data-collection-total") ||
            tmp.querySelector(".custom-total-product")?.textContent ||
            tmp.querySelector("#ProductCount")?.textContent ||
            tmp.querySelector("#ProductCountDesktop")?.textContent ||
            ""
          const n =
            parsePositiveInt(rawTotal) || parseLastPositiveInt(rawTotal) || 0
          if (Number.isFinite(n) && n > 0) {
            window.__yotpoRatingServerTotals =
              window.__yotpoRatingServerTotals || {}
            window.__yotpoRatingServerTotals[key] = n
          }
        } catch (_) {}

        try {
          window.__lastFacetRequestKey = getRequestKeyForUrl(cleanUrl)
        } catch (_) {}

        // Replace product grid
        const newGrid = tmp.querySelector("#ProductGridContainer")
        const curGrid = document.querySelector("#ProductGridContainer")
        if (newGrid && curGrid) {
          curGrid.innerHTML = newGrid.innerHTML
          if (typeof theme_custom?.percussiveMassageSlider === "function") {
            theme_custom.percussiveMassageSlider()
          }
          // If the rating filter overlay exists, re-mount it (innerHTML replacement nukes it).
          try {
            const overlay = document.getElementById(
              "yotpo-rating-filter-overlay",
            )
            if (overlay) curGrid.appendChild(overlay)
          } catch (_) {}
          // Delay load-more count update to ensure grid has been rendered
          setTimeout(() => {
            if (hasRatingMin) return
            const updatedGrid = document.querySelector("#ProductGridContainer")
            const visibleCount =
              updatedGrid?.querySelectorAll(
                "li.grid__item:not(.daily-deals-injected)",
              ).length || 0
            const countElem = document.querySelector(".custom-show-product")
            if (countElem) countElem.textContent = visibleCount.toString()
          }, 0)
        }
        const totalElem = document.querySelector(".custom-total-product")

        const newTotalElem = tmp.querySelector(".custom-total-product")
        if (!hasRatingMin && newTotalElem && totalElem) {
          totalElem.textContent = newTotalElem.textContent
        }

        const progress = document.querySelector(".load-more-progress-bar")
        const countElem = document.querySelector(".custom-show-product")
        if (!hasRatingMin && progress && countElem && totalElem) {
          const total = parseInt(totalElem.textContent || "0")
          const shown = parseInt(countElem.textContent || "0")
          progress.style.width = `${(shown / total) * 100}%`
        }

        // Replace drawer filters (mobile) - preserve scroll and avoid full replacement
        const newDrawer = tmp.querySelector("#FacetFiltersFormMobile")
        const curDrawer = document.querySelector("#FacetFiltersFormMobile")
        if (curDrawer && newDrawer) {
          const innerOld = curDrawer.querySelector(".mobile-facets__inner")
          const innerNew = newDrawer.querySelector(".mobile-facets__inner")

          if (innerOld && innerNew) {
            const scrollTop = innerOld.scrollTop

            const mainOld = innerOld.querySelector(".mobile-facets__main")
            const mainNew = innerNew.querySelector(".mobile-facets__main")

            if (mainOld && mainNew) {
              mainOld.innerHTML = mainNew.innerHTML
            }

            setTimeout(() => {
              innerOld.scrollTop = scrollTop
              syncAll() // rebind filters
            }, 0)
          }
        }

        const newDrawerDesktop = tmp.querySelector("#FacetFiltersForm")
        const curDrawerDesktop = document.querySelector("#FacetFiltersForm")
        if (newDrawerDesktop && curDrawerDesktop) {
          const scrollY = curDrawerDesktop.scrollTop
          curDrawerDesktop.replaceWith(newDrawerDesktop)
          newDrawerDesktop.scrollTop = scrollY
        }

        // ✅ Replace .load-more-part after filters are applied
        const newLoadMore = tmp.querySelector(".load-more-part")
        const curLoadMore = document.querySelector(".load-more-part")
        if (newLoadMore && curLoadMore) {
          curLoadMore.replaceWith(newLoadMore.cloneNode(true))
        } else if (!newLoadMore && curLoadMore) {
          // When the server result set is 1 page, `.load-more-part` disappears; remove any stale DOM.
          curLoadMore.remove()
        } else if (newLoadMore && !curLoadMore) {
          // If it re-appears (filters expanded back to multiple pages), insert it into the grid container.
          const host =
            document.querySelector("#ProductGridContainer .collection") ||
            document.querySelector("#ProductGridContainer")
          if (host) host.appendChild(newLoadMore.cloneNode(true))
        }

        // If rating filter is active, hide "Show more" when we load all products client-side.
        try {
          if (hasRatingMin) {
            setTimeout(() => {
              const loadMorePart = document.querySelector(".load-more-part")
              const loadAllForRating =
                window.__yotpoRatingLoadAllProducts === true ||
                (window.__yotpoRatingLoadAllProducts !== false && hasRatingMin)
              if (loadMorePart)
                loadMorePart.style.display = loadAllForRating ? "none" : ""
            }, 0)
          } else {
            const loadMorePart = document.querySelector(".load-more-part")
            if (loadMorePart) loadMorePart.style.display = ""
          }
        } catch (_) {}

        // Re-extract most popular options
        mostPopularOptionsFromResponse =
          extractLiveMostPopularOptionsFromDOM(tmp)

        // Rebind everything
        syncAll()
        // Re-bind Show More button using global rebind
        setTimeout(() => {
          rebindShowMoreButton()
          syncLoadMoreUI()
        }, 0)
        // --- Remove unavailable unmatched Most Popular pills after content load ---
        removeUnavailableUnmatchedPills(html)
        // --- [PATCH] Ensure unmatched Most Popular pills are created after DOM/filter updates ---
        if (typeof createUnmatchedMostPopularPills === "function") {
          requestAnimationFrame(() => {
            setTimeout(() => {
              createUnmatchedMostPopularPills()
              // [PATCH] Ensure pills are cleaned up after all DOM and pill rendering is complete
              setTimeout(removeUnavailableUnmatchedPills, 100)
              initBadges()
              checkProductCardsPromoTextHeight()
            }, 100)
          })
        }
        filterSelectionTag.track()
      } catch (e) {
        if (e?.name === "AbortError") return
        // Do nothing
      } finally {
        if (requestId !== loadContentRequestId) return
        document
          .querySelectorAll(".quick-filter-pill")
          .forEach((pill) => pill.classList.remove("disabled"))
        if (typeof attachMobileClearHandler === "function")
          attachMobileClearHandler()

        document.dispatchEvent(
          new Event("filter:applied", { bubbles: true, composed: true }),
        )
      }
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null
    }

    // --- Helper to remove unavailable or unmatched Most Popular pills ---
    // Removes unmatched "Most Popular" pills that are no longer available/checked in the drawer
    function removeUnavailableUnmatchedPills() {
      setTimeout(() => {
        const pills = Array.from(
          document.querySelectorAll(
            '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
          ),
        )
        let pillRemoved = false
        pills.forEach((pill) => {
          const pillRaw = pill.getAttribute("data-p")?.split("|")[1] || ""
          const normalized = pillRaw
            .replace(/\+/g, " ")
            .replace(/%20/g, " ")
            .replace(/\s+/g, " ")
            .replace(/[^a-z0-9 ]+/gi, "")
            .toLowerCase()
            .trim()
          const drawerCheckbox = Array.from(
            document.querySelectorAll(
              'input[name="filter.p.m.custom.most_popular"]',
            ),
          ).find((input) => {
            return (
              (input.value || "")
                .replace(/\+/g, " ")
                .replace(/%20/g, " ")
                .replace(/\s+/g, " ")
                .replace(/[^a-z0-9 ]+/gi, "")
                .toLowerCase()
                .trim() === normalized
            )
          })
          if (!drawerCheckbox || !drawerCheckbox.checked) {
            pill.remove()
            pillRemoved = true
          }
        })
        // Only scroll left if not suppressed by quick filter click
        if (pillRemoved) {
          if (!window.suppressNextPillScroll) {
            setTimeout(scrollQuickFilterMainLeft, 50)
          }
        }
      }, 50)
    }

    // Sets up price filter input events to sanitize and trigger AJAX updates
    function setupPriceFilters() {
      if (!drawerForm) return

      const priceInputs = [
        drawerForm.querySelector('input[name="filter.v.price.gte"]'),
        drawerForm.querySelector('input[name="filter.v.price.lte"]'),
      ].filter(Boolean)

      priceInputs.forEach((input) => {
        // Clone input to remove problematic event listeners
        const newInput = input.cloneNode(true)
        input.replaceWith(newInput)

        // Store current cursor position
        let cursorPosition = 0

        newInput.addEventListener("keydown", (e) => {
          cursorPosition = e.target.selectionStart
          if (e.key === "Enter") {
            applyPriceFilters()
          }
        })

        newInput.addEventListener("input", (e) => {
          const newValue = e.target.value.replace(/[^0-9]/g, "")
          if (newValue !== e.target.value) {
            e.target.value = newValue
            newInput.setSelectionRange(cursorPosition, cursorPosition)
          }
        })

        newInput.addEventListener("blur", debounce(applyPriceFilters, 300))
      })
    }

    // Clears all sort radio buttons and removes their active states
    function clearSortRadios() {
      // Uncheck all sort radios
      document
        .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
        .forEach((radio) => {
          radio.checked = false
        })
      // Remove active class from labels
      document.querySelectorAll(".mobile-facets__label").forEach((label) => {
        label.classList.remove("active")
      })

      // After clearing, set "Featured" (manual) as the default selected option
      // BUT don't check the radio to prevent it from being included in filters
      const featuredRadio = document.querySelector(
        'input[name="sort_by"][value="manual"]',
      )
      if (featuredRadio) {
        // Don't check the radio - just add active class to show visual selection
        featuredRadio.checked = false

        // Add active class to the Featured label to show it as selected
        const featuredLabel = featuredRadio.closest(".mobile-facets__label")
        if (featuredLabel) {
          featuredLabel.classList.add("active")
        }
      }
    }

    // Rebinds price range input events in <price-range> components to trigger AJAX updates
    function rebindPriceRangeInputs() {
      const priceComponents = document.querySelectorAll("price-range")
      priceComponents.forEach((range) => {
        const minInput = range.querySelector('input[name="filter.v.price.gte"]')
        const maxInput = range.querySelector('input[name="filter.v.price.lte"]')

        if (!minInput || minInput.classList.contains("price-bound")) return

        const updatePrice = () => {
          const filters = getFilters()
          const minVal = minInput.value.trim()
          const maxVal = maxInput.value.trim()

          // Only include valid prices
          if (minVal && !isNaN(minVal)) {
            filters["filter.v.price.gte"] = [minVal]
          } else {
            delete filters["filter.v.price.gte"]
          }

          if (maxVal && !isNaN(maxVal)) {
            filters["filter.v.price.lte"] = [maxVal]
          } else {
            delete filters["filter.v.price.lte"]
          }

          if (minVal || maxVal) {
            updateURL(filters)
          }
        }

        // Blur triggers AJAX update
        minInput.addEventListener("blur", updatePrice)
        maxInput.addEventListener("blur", updatePrice)

        // Enter key
        minInput.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            updatePrice()
          }
        })
        maxInput.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            updatePrice()
          }
        })

        // Prevent instant reload on typing
        minInput.addEventListener("input", (e) => e.stopPropagation())
        maxInput.addEventListener("input", (e) => e.stopPropagation())

        // Mark as bound
        minInput.classList.add("price-bound")
        maxInput.classList.add("price-bound")
      })
    }

    // Removes the 'data-max' attribute from price range inputs to allow any value
    function fixPriceRangeDataMax() {
      document
        .querySelectorAll('price-range input[name="filter.v.price.gte"]')
        .forEach((input) => {
          if (input.hasAttribute("data-max")) {
            input.removeAttribute("data-max") // 🛠 remove limit
          }
        })

      document
        .querySelectorAll('price-range input[name="filter.v.price.lte"]')
        .forEach((input) => {
          if (input.hasAttribute("data-max")) {
            input.removeAttribute("data-max") // 🛠 remove limit
          }
        })
    }

    // Safely binds blur and Enter key events to price inputs to trigger filter updates
    function bindPriceEventsSafely() {
      document
        .querySelectorAll('price-range input[name^="filter.v.price"]')
        .forEach((input) => {
          if (input.classList.contains("price-bound")) return

          input.addEventListener("blur", () => {
            const filters = getFilters()
            updateURL(filters)
          })

          input.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              e.preventDefault()
              const filters = getFilters()
              updateURL(filters)
            }
          })

          input.classList.add("price-bound")
        })
    }

    // Binds the drawer clear button to reset filters and trigger AJAX reload
    function setupDrawerClearButton() {
      const drawerClearBtn = document.querySelector(
        ".mobile-facets__clear.button--secondary",
      )

      if (!drawerClearBtn || drawerClearBtn.classList.contains("bound")) return

      drawerClearBtn.addEventListener("click", (e) => {
        e.preventDefault()

        // Reset URL to base collection
        const url = new URL(
          window.location.origin + drawerClearBtn.getAttribute("href"),
        )

        // Wipe filters from the drawer checkboxes
        document
          .querySelectorAll("#FacetFiltersFormMobile input[type='checkbox']")
          .forEach((el) => {
            el.checked = false
          })

        // Clear price inputs if needed
        document
          .querySelectorAll("#FacetFiltersFormMobile input[type='text']")
          .forEach((el) => {
            el.value = ""
          })

        // Trigger AJAX content reload
        loadContent({}) // empty filters

        // Scroll to left after DOM update
        setTimeout(scrollQuickFilterMainLeft, 100)
      })

      drawerClearBtn.classList.add("bound")
    }

    // Rebinds all filter, sort, and price events; syncs UI state; ensures pill and drawer consistency
    function syncAll() {
      // Rebind drawerForm element
      drawerForm = document.querySelector(drawerSelector)

      // Prevent Dawn's default form submission behavior
      document
        .querySelectorAll("#FacetFiltersForm, #FacetFiltersFormMobile")
        .forEach((form) => {
          form.addEventListener("submit", (e) => e.preventDefault())
        })

      // Rebind all checkbox events to submit filters
      if (drawerForm) {
        drawerForm
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            if (!input.classList.contains("bound")) {
              input.addEventListener("change", (e) => {
                e.preventDefault()
                e.stopPropagation()
                // --- Matched vs Unmatched behavior for Most Popular ---
                let isMostPopular =
                  e.target.name === "filter.p.m.custom.most_popular"
                if (isMostPopular) {
                  const rawVal = e.target.value || ""
                  // Unified normalization (handles +, %20, slashes, punctuation)
                  const norm = (s) =>
                    decodeURIComponent(s || "")
                      .replace(/\+/g, " ")
                      .replace(/%20/g, " ")
                      .replace(/\s+/g, " ")
                      .replace(/[^a-z0-9 ]+/gi, "")
                      .toLowerCase()
                      .trim()
                  // Does a quick filter button exist for this value?
                  const hasQuickBtn = Array.from(
                    document.querySelectorAll(
                      ".quick-filter-main .custom-button a",
                    ),
                  ).some((a) => {
                    const btnUrl = new URL(a.href, location.origin)
                    const btnVal =
                      btnUrl.searchParams.get(
                        "filter.p.m.custom.most_popular",
                      ) || ""
                    return norm(btnVal) === norm(rawVal)
                  })

                  if (hasQuickBtn && e.target.checked) {
                    // Matched add: scroll to button (handled in renderQuick), no left snap
                    window.justAddedMostPopular = e.target.value
                    window.forceScrollLeftAfterRender = false
                    window.forceScrollLeftValue = null
                    window.blockLeftScrollThisRender = true
                    window.forceScrollPriority = false
                  } else if (hasQuickBtn && !e.target.checked) {
                    // Matched remove: keep current scroll position (no left snap)
                    window.justAddedMostPopular = false
                    window.forceScrollLeftAfterRender = false
                    window.forceScrollLeftValue = null
                    // do not force
                    window.blockLeftScrollThisRender = false
                    window.forceScrollPriority = false
                  } else {
                    // Unmatched add/remove: force left snap
                    window.justAddedMostPopular = false
                    window.forceScrollLeftAfterRender = true
                    window.forceScrollLeftValue = norm(rawVal)
                    window.blockLeftScrollThisRender = false
                    // If this is an unmatched **removal**, make it priority so nothing suppresses it
                    if (!e.target.checked) {
                      window.forceScrollPriority = true
                    } else {
                      window.forceScrollPriority = false
                    }
                  }
                }
                // Always snap left on uncheck/removal from the drawer (any checkbox)
                if (
                  e.target &&
                  e.target.type === "checkbox" &&
                  e.target.checked === false
                ) {
                  const qfm = document.querySelector(".quick-filter-main")
                  const gutter = getMobileGutterPx()
                  window.__quickFilterDesiredLeft = gutter
                  window.forceScrollLeftAfterRender = true
                  window.forceScrollPriority = true
                  window.blockLeftScrollThisRender = false
                }
                window.quickFilterJustAdded = true
                updateURL(getFilters())
                // For non-Most Popular filters, always snap left after render
                if (!isMostPopular) {
                  window.forceScrollLeftAfterRender = true
                  window.forceScrollPriority = true
                  window.blockLeftScrollThisRender = false
                  document.dispatchEvent(new Event("filter:change"))
                }
                // No longer remove pills for checked Most Popular inputs here; handled in removeUnavailableUnmatchedPills.
              })
              input.classList.add("bound")
            }
          })
      }

      function resetSortToDefaultFromDrawer() {
        const filters = getFilters()
        delete filters["sort_by"]

        // Reset sort flags and prevent any "Featured" pill creation.
        window.userSelectedSort = false
        window.userManuallySorted = false
        window.__sortPillRemoved = true

        // Uncheck all radios and reset label active states. Dawn uses "Featured" as the visual default.
        document.querySelectorAll('input[name="sort_by"]').forEach((r) => {
          r.checked = false
          const label = r.closest(".mobile-facets__label")
          if (label) label.classList.remove("active")
        })
        const featuredRadio = document.querySelector(
          'input[name="sort_by"][value="manual"]',
        )
        const featuredLabel = featuredRadio?.closest(".mobile-facets__label")
        if (featuredLabel) featuredLabel.classList.add("active")

        window.quickFilterJustAdded = true
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        document.dispatchEvent(new Event("filter:change"))

        updateURL(filters)
      }

      function handleSortChange(e) {
        const radio = e.target
        if (!radio || !radio.value) return

        // Treat "Featured" as the default state (no sort_by in URL).
        if (radio.value === "manual") {
          resetSortToDefaultFromDrawer()
          return
        }

        const filters = getFilters()
        filters["sort_by"] = [radio.value]

        window.userSelectedSort = true
        window.userManuallySorted = true
        window.__sortPillRemoved = false // Reset the protection flag when user explicitly selects a sort

        window.quickFilterJustAdded = true
        // Ensure left snap even on iOS after sort selection
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        document.dispatchEvent(new Event("filter:change"))
        updateURL(filters)
      }

      function handleSortPointerDown(e) {
        const radio = e.currentTarget
        if (!radio) return
        radio.dataset.wasChecked = radio.checked ? "1" : "0"
      }

      function handleSortKeyDown(e) {
        if (e.key !== "Enter" && e.key !== " ") return
        handleSortPointerDown(e)
      }

      function handleSortClick(e) {
        const radio = e.currentTarget
        if (!radio) return

        const wasChecked = radio.dataset.wasChecked === "1"
        const isFeatured = radio.value === "manual"

        // Clicking "Featured" should always clear sort_by (reset to default).
        if (isFeatured) {
          e.preventDefault()
          e.stopPropagation()
          resetSortToDefaultFromDrawer()
          return
        }

        // Clicking the currently-selected sort option should remove sort_by (like a toggle).
        if (wasChecked) {
          e.preventDefault()
          e.stopPropagation()
          resetSortToDefaultFromDrawer()
        }
      }

      const sortRadios = document.querySelectorAll('input[name="sort_by"]')
      sortRadios.forEach((radio) => {
        if (!radio || radio.dataset.sortBound === "1") return
        radio.dataset.sortBound = "1"
        radio.addEventListener("change", handleSortChange)
        radio.addEventListener("pointerdown", handleSortPointerDown)
        radio.addEventListener("mousedown", handleSortPointerDown)
        radio.addEventListener("keydown", handleSortKeyDown)
        radio.addEventListener("click", handleSortClick)
      })

      // Rebind price input events (call only once)
      bindPriceEventsSafely()
      rebindPriceRangeInputs()
      setupPriceFilters()
      const filters = getFilters()

      if (drawerForm) {
        drawerForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
          cb.checked = !!filters[cb.name]?.includes(cb.value)
        })

        const minInput = drawerForm.querySelector(
          'input[name="filter.v.price.gte"]',
        )
        const maxInput = drawerForm.querySelector(
          'input[name="filter.v.price.lte"]',
        )
        if (minInput) minInput.value = filters["filter.v.price.gte"]?.[0] || ""
        if (maxInput) maxInput.value = filters["filter.v.price.lte"]?.[0] || ""

        // Open all filter accordions
        drawerForm.querySelectorAll("details").forEach((d) => (d.open = true))
      }

      // Sync sort radios
      const urlParams = new URLSearchParams(window.location.search)
      const sortBy = urlParams.get("sort_by")

      document
        .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
        .forEach((radio) => {
          // Special handling for "Featured" (manual) sort: check if explicitly selected OR if it's the default
          if (radio.value === "manual") {
            // Only check the radio if user explicitly selected it
            const shouldCheck = sortBy === "manual" && window.userManuallySorted
            radio.checked = shouldCheck

            const label = radio.closest(".mobile-facets__label")
            if (label) {
              // Show as active if explicitly selected OR if it's the default (no sort selected)
              const shouldShowActive = shouldCheck || !sortBy
              if (shouldShowActive) {
                label.classList.add("active")
              } else {
                label.classList.remove("active")
              }
            }
          } else {
            // Normal handling for other sort options
            const isChecked = radio.value === sortBy
            radio.checked = isChecked

            const label = radio.closest(".mobile-facets__label")
            if (label) {
              if (isChecked && !radio.dataset.default) {
                label.classList.add("active")
              } else {
                label.classList.remove("active")
              }
            }
          }
        })

      // Only retain sort_by in filters if user actually selected it via URL
      // if (!sortBy) {
      //   delete filters["sort_by"]
      // }

      // Ensure "Featured" (manual) sort is never treated as selected unless explicitly chosen
      if (sortBy === "manual" && !window.userManuallySorted) {
        // Remove manual sort from filters to prevent Featured pill creation
        delete filters["sort_by"]
      }

      // Ensure Featured label has active class when it's the default (no sort selected)
      if (!sortBy) {
        const featuredRadio = document.querySelector(
          'input[name="sort_by"][value="manual"]',
        )
        if (featuredRadio) {
          const featuredLabel = featuredRadio.closest(".mobile-facets__label")
          if (featuredLabel) {
            featuredLabel.classList.add("active")
          }
        }
      }

      renderQuick(filters)

      // EXTREME PROTECTION: Remove any "Featured" pills that might have been created
      setTimeout(() => {
        if (!window.userManuallySorted) {
          const featuredPills = document.querySelectorAll(
            '.quick-filter-pill[data-sort-by="manual"]',
          )
          featuredPills.forEach((pill) => pill.remove())
        }
      }, 100)

      // --- [PATCH: Ensure Sort Pill Label Is Always Up To Date After AJAX, Both Radios & Select] ---
      setTimeout(function () {
        const sortByPill = document.querySelector(
          ".quick-filter-pill[data-sort-by]",
        )
        let sortLabel = null
        // Prefer radio label
        const sortRadio = document.querySelector(
          'input[name="sort_by"]:checked',
        )
        if (sortRadio) {
          let labelElem =
            document.querySelector(`label[for="${sortRadio.id}"]`) ||
            sortRadio.closest("label") ||
            sortRadio.parentElement
          if (labelElem) {
            sortLabel = labelElem.textContent.trim()
          }
        } else {
          // Fallback: select box
          const sortSelect = document.querySelector('select[name="sort_by"]')
          if (sortSelect) {
            const selected = sortSelect.querySelector("option:checked")
            if (selected) {
              sortLabel = selected.textContent.trim()
            }
          }
        }
        if (sortByPill && sortLabel) {
          sortByPill.textContent = sortLabel
        }
      }, 80)
      // Removed scrollLeft reset for quick filters container on syncAll
      rebindPriceRangeInputs()
      fixPriceRangeDataMax()
      setupDrawerClearButton()
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null
    }

    // Shows or hides the mobile clear filters button based on active pills
    function toggleMobileClearButton() {
      const clearBtn = document.querySelector(".clear-filters-mobile-only")
      const anyActive =
        document.querySelectorAll(".quick-filter-pill").length > 0
      if (clearBtn) clearBtn.style.display = anyActive ? "flex" : "none"
    }

    // Renders all quick filter pills based on current filters and pill order; updates UI and scrolls as needed
    function renderQuick(filters) {
      // --- [SCROLL PATCH: Separate unmatched Most Popular and quick filter click scroll logic] ---
      // Determine if a scroll should occur for unmatched Most Popular add/remove or quick filter click
      let mostPopularChangedType = null
      if (
        window.forceScrollLeftAfterRender &&
        (!window.blockLeftScrollThisRender || window.forceScrollPriority)
      ) {
        // Branch A: unmatched Most Popular add/remove
        mostPopularChangedType = "unmatched-add"
        if (window.forceScrollPriority) {
          mostPopularChangedType = "unmatched-remove"
        }
      }
      let lastQuickFilterClicked = window._lastQuickFilterClickedValue || null
      // --- Branch A: unmatched Most Popular add/remove scroll ---
      if (
        mostPopularChangedType === "unmatched-add" ||
        mostPopularChangedType === "unmatched-remove"
      ) {
        const quickFilterMain = document.querySelector(".quick-filter-main")
        if (quickFilterMain) {
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(quickFilterMain, true, mobileGutter)
        }
        // Reset scroll flags for unmatched Most Popular
        window.forceScrollLeftAfterRender = false
        window.forceScrollLeftValue = null
        window.forceScrollPriority = false
        // Clear quick filter click value to avoid duplicate scroll
        window._lastQuickFilterClickedValue = null
        return
      }
      // --- Branch B: quick filter click scroll ---
      if (lastQuickFilterClicked) {
        const quickFilterMain = document.querySelector(".quick-filter-main")
        if (quickFilterMain) {
          const clickedPill = quickFilterMain.querySelector(
            `[data-filter-value="${lastQuickFilterClicked}"]`,
          )
          if (clickedPill) {
            // Align selected pill left using container's CSS padding-left
            const cs = window.getComputedStyle(quickFilterMain)
            const gutter = parseInt(cs.paddingLeft, 10) || 16
            const maxLeft = Math.max(
              0,
              quickFilterMain.scrollWidth - quickFilterMain.clientWidth,
            )
            const targetLeft = Math.max(
              0,
              Math.min(clickedPill.offsetLeft - gutter, maxLeft),
            )
            quickFilterMain.scrollTo({ left: targetLeft, behavior: "smooth" })
            window._lastQuickFilterClickedValue = null
            return
          }
        }
        window._lastQuickFilterClickedValue = null
      }
      // --- [END PATCH: New scroll branches] ---
      // Remove neighbor scroll logic per latest requirement: keep position on deselect
      window._neighborPillIndexAfterRemoval = null
      // Center the exact quick filter button that was clicked (based on stored key/value)
      if (window._lastQuickFilterClicked) {
        const { key, value } = window._lastQuickFilterClicked
        const quickFilterMain = document.querySelector(".quick-filter-main")
        let targetBtn = null
        if (quickFilterMain) {
          const buttons = quickFilterMain.querySelectorAll(".custom-button a")
          buttons.forEach((a) => {
            if (targetBtn) return
            try {
              const url = new URL(a.href, location.origin)
              const val = url.searchParams.get(key)
              if (val && val.toString() === value.toString()) {
                targetBtn = a
              }
            } catch (_) {}
          })
        }

        if (targetBtn) {
          // Align selected quick filter to the left edge of the container with proper gutter
          const container = document.querySelector(".quick-filter-main")
          if (container) {
            // Get the actual padding-left from CSS
            const computedStyle = window.getComputedStyle(container)
            const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0
            const btnLeft = targetBtn.offsetLeft
            const containerWidth = container.clientWidth
            const maxLeft = Math.max(0, container.scrollWidth - containerWidth)
            const targetLeft = Math.max(
              0,
              Math.min(btnLeft - paddingLeft, maxLeft),
            )
            container.scrollTo({ left: targetLeft, behavior: "smooth" })
          } else {
            targetBtn.scrollIntoView({
              inline: "start",
              behavior: "smooth",
              block: "nearest",
            })
          }
        }
        window._lastQuickFilterClicked = null
      }
      // --- [MOVE suppression logic to very top of renderQuick before any DOM or scroll logic] ---
      // Before rendering, collect all current 'Most Popular' pill values
      const quickFilterPillsBefore = document.querySelectorAll(
        '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
      )
      const mostPopularValuesBefore = new Set()
      quickFilterPillsBefore.forEach((pill) => {
        let pillValue = pill.getAttribute("data-p").split("|")[1]
        if (pillValue) {
          pillValue = decodeURIComponent(pillValue).trim().toLowerCase()
          mostPopularValuesBefore.add(pillValue)
        }
      })
      let pillOrderArr = getPillOrderArr()
      // --- Early first-time matched Most Popular scroll ---
      if (
        mostPopularValuesBefore &&
        Array.isArray([...mostPopularValuesBefore]) &&
        [...mostPopularValuesBefore].length === 0
      ) {
        // Determine if the newest filter is from Most Popular and matches a quick filter
        const mostPopularParam = filters.find
          ? filters.find((f) => f.paramName === "filter.p.most_popular")
          : null
        if (mostPopularParam) {
          const mpValue = mostPopularParam.value?.toLowerCase()
          const quickBtn = document.querySelector(
            `.quick-filters-container [data-value="${mpValue}"]`,
          )
          if (quickBtn) {
            requestAnimationFrame(() => {
              // Custom scroll that respects padding
              const container = document.querySelector(".quick-filter-main")
              if (container) {
                const computedStyle = window.getComputedStyle(container)
                const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0
                const btnLeft = quickBtn.offsetLeft
                const containerWidth = container.clientWidth
                const maxLeft = Math.max(
                  0,
                  container.scrollWidth - containerWidth,
                )
                const targetLeft = Math.max(
                  0,
                  Math.min(btnLeft - paddingLeft, maxLeft),
                )
                container.scrollTo({ left: targetLeft, behavior: "smooth" })
              } else {
                quickBtn.scrollIntoView({
                  behavior: "smooth",
                  inline: "start",
                  block: "nearest",
                })
              }
            })
            window.blockLeftScrollThisRender = true
            window.__suppressNextQuickFilterScroll = true
          }
        }
      }
      // --- End early first-time matched scroll ---
      // Suppress scroll ONLY if the most recently added pill is a Most Popular pill AND it existed before rendering
      let suppressPillScroll = false
      // Forced suppression: if last event was a quick filter click, always suppress scroll
      if (
        window.quickFilterLastEvent &&
        window.quickFilterLastEvent.target &&
        window.quickFilterLastEvent.target.closest(".custom-button a")
      ) {
        suppressPillScroll = true
        window.quickFilterLastEvent = null
      }
      if (
        pillOrderArr.length > 0 &&
        pillOrderArr[0][0] === "filter.p.m.custom.most_popular"
      ) {
        let mostPopularValue = pillOrderArr[0][1]
        mostPopularValue = decodeURIComponent(mostPopularValue)
          .trim()
          .toLowerCase()
        if (mostPopularValuesBefore.has(mostPopularValue)) {
          suppressPillScroll = true
        } else {
        }
      }
      localStorage.removeItem("suppressNextPillScroll") // only use once
      // --- Only after all suppression logic is set, render the pills ---
      if (!mostPopularOptionsFromResponse?.length) {
        mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()
      }
      let scrolledOnce = false
      // Prevent flicker/blink when clicking on quick filter: If a quick filter was just clicked, skip full pill rebuild for this event.
      // Strong pill-flicker prevention: skip rendering for 200ms after quick filter click
      if (window.justClickedQuickFilter) {
        if (!window.justClickedQuickFilterTimestamp) {
          window.justClickedQuickFilterTimestamp = Date.now()
        }
        // If within 200ms of click, skip rendering
        if (Date.now() - window.justClickedQuickFilterTimestamp < 200) {
          return
        } else {
          window.justClickedQuickFilter = false
          window.justClickedQuickFilterTimestamp = null
        }
      }

      const prevPillCount = quickContainer.children.length
      // Hide container during rebuild to avoid mid-frame flicker (e.g., Featured pill)
      const __prevVisibility = quickContainer.style.visibility
      quickContainer.style.visibility = "hidden"

      // During clear operations, completely block pill creation to prevent flicker
      if (window.__isClearingFilters) {
        quickContainer.innerHTML = ""
        return // Exit early, don't create any pills during clear
      }

      // Safety: ensure filters object doesn't contain "manual" sort unless explicitly selected
      if (
        filters["sort_by"] &&
        filters["sort_by"][0] === "manual" &&
        !window.userManuallySorted
      ) {
        delete filters["sort_by"]
      }

      // EXTREME SAFETY: Completely remove ALL sort_by from filters if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        delete filters["sort_by"]
      }

      // EXTREME SAFETY: Completely remove ALL sort_by from filters if sort pill was recently removed
      if (window.__sortPillRemoved) {
        delete filters["sort_by"]
      }

      quickContainer.innerHTML = ""
      // --- PATCH: Ensure all active filters are present in pillOrderArr (leftmost is newest) ---
      // --- PATCH: All pills (including sort_by) behave as "newest leftmost" ---
      // 1. Start from pillOrderArr from localStorage
      pillOrderArr = getPillOrderArr()

      // 2. Add any selected filters (including sort_by) not present in pillOrderArr (unshift: leftmost/newest)
      Object.entries(filters).forEach(([key, values]) => {
        if (key.startsWith("filter.v.price")) return
        // Rating quick filter is URL-driven but should NOT create a separate "active pill"
        // (otherwise it duplicates the existing quick filter button UI).
        if (key === "yotpo_rating_min") return

        // EXTREME SAFETY: Never add ANY sort_by entries unless user explicitly selected Featured
        if (key === "sort_by" && !window.userManuallySorted) {
          return
        }

        // EXTREME SAFETY: Never add ANY sort_by entries if sort pill was recently removed
        if (key === "sort_by" && window.__sortPillRemoved) {
          return
        }

        // Only add sort_by pills if NOT default manual, unless the user explicitly selected it
        if (
          key === "sort_by" &&
          (!values || (values[0] === "manual" && !window.userManuallySorted))
        )
          return
        values.forEach((value) => {
          // Extra safety: never add "manual" sort pills unless explicitly selected
          if (
            key === "sort_by" &&
            value === "manual" &&
            !window.userManuallySorted
          ) {
            return
          }
          const exists = pillOrderArr.some(([k, v]) => k === key && v === value)
          if (!exists) {
            pillOrderArr.unshift([key, value])
          }
        })
      })

      // 3. Remove pills no longer selected
      pillOrderArr = pillOrderArr.filter(([key, value]) => {
        // Never render an "active pill" for rating quick filter; it should only appear as a quick filter button.
        if (key === "yotpo_rating_min") return false
        if (key === "sort_by") {
          // Only keep if explicitly selected by the user AND not the default "manual" value
          return (
            !!filters["sort_by"] &&
            filters["sort_by"][0] === value &&
            (value !== "manual" || window.userManuallySorted)
          )
        }
        if (key === "price") {
          const min = filters["filter.v.price.gte"]?.[0] || ""
          const max = filters["filter.v.price.lte"]?.[0] || ""
          return value === `${min}_${max}` && (min || max)
        }
        return filters[key]?.includes(value)
      })

      // Additional safety check: remove any "manual" sort pills if user hasn't explicitly selected them
      pillOrderArr = pillOrderArr.filter(([key, value]) => {
        if (
          key === "sort_by" &&
          value === "manual" &&
          !window.userManuallySorted
        ) {
          return false
        }
        return true
      })

      // 4. Save order
      setPillOrderArr(pillOrderArr)

      // Final safety check: ensure no "manual" sort entries exist in pillOrderArr unless explicitly selected
      if (!window.userManuallySorted) {
        pillOrderArr = pillOrderArr.filter(
          ([key, value]) => !(key === "sort_by" && value === "manual"),
        )
        setPillOrderArr(pillOrderArr)
      }

      // EXTREME PROTECTION: Completely remove ALL sort_by entries if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        pillOrderArr = pillOrderArr.filter(([key, value]) => key !== "sort_by")
        setPillOrderArr(pillOrderArr)
      }

      // --- PATCH: Remove duplicate Most Popular entries from pillOrderArr ---
      const seenMostPopular = new Set()
      pillOrderArr = pillOrderArr.filter(([key, value]) => {
        if (key === "filter.p.m.custom.most_popular") {
          const norm = (value || "").trim().toLowerCase()
          if (seenMostPopular.has(norm)) return false // Remove duplicates
          seenMostPopular.add(norm)
        }
        return true
      })

      // --- Sync quick filter button "selected" state to match filters ---
      document
        .querySelectorAll(".quick-filter-main .custom-button a")
        .forEach((a) => {
          const params = new URL(a.href, location.origin).searchParams
          const filterKey = [...params.keys()].find((k) =>
            k.startsWith("filter.p.m.custom.most_popular"),
          )
          if (!filterKey) return
          const filterValue = params.get(filterKey)
          // Mark as selected if this filter/value is active
          a.classList.toggle(
            "selected",
            filters[filterKey]?.includes(filterValue),
          )
        })

      // --- PATCH: Scroll to matched quick filter when Most Popular is selected from drawer ---
      if (
        window.justAddedMostPopular &&
        typeof window.justAddedMostPopular === "string"
      ) {
        const norm = (s) =>
          decodeURIComponent(s || "")
            .replace(/\+/g, " ")
            .replace(/%20/g, " ")
            .replace(/\s+/g, " ")
            .replace(/[^a-z0-9 ]+/gi, "")
            .toLowerCase()
            .trim()

        const matchValue = norm(window.justAddedMostPopular)
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return btnVal && norm(btnVal) === matchValue
        })
        if (quickBtn) {
          const container = document.querySelector(".quick-filter-main")

          const getOffsetLeftWithin = (el, ancestor) => {
            let x = 0,
              n = el
            while (n && n !== ancestor) {
              x += n.offsetLeft || 0
              n = n.offsetParent
            }
            return x
          }

          requestAnimationFrame(() => {
            if (container) {
              const cs = window.getComputedStyle(container)
              const paddingLeft = parseInt(cs.paddingLeft, 10) || 16
              const targetLeft = Math.max(
                0,
                getOffsetLeftWithin(quickBtn, container) - paddingLeft,
              )
              const before = container.scrollLeft
              container.scrollTo({ left: targetLeft, behavior: "smooth" })
              setTimeout(() => {
                const after = container.scrollLeft
                const needsRetry = Math.abs(after - targetLeft) > 2
                if (needsRetry) {
                  container.scrollTo({ left: targetLeft, behavior: "auto" })
                }
              }, 60)
              // Prevent any left snap after matched scroll
              window.blockLeftScrollThisRender = true
              window.__suppressNextQuickFilterScroll = true
            }
          })
        }
        // Reset the flag for next render
        window.justAddedMostPopular = false
      }

      // 5. Render: newest at left
      ;[...pillOrderArr].reverse().forEach(([key, value]) => {
        // Insert deduplication/visibility logic for Most Popular before pill creation (NEW LOGIC)
        if (key === "filter.p.m.custom.most_popular") {
          const normalizedValue = value.trim().toLowerCase()
          // PATCH: Removed DOM-based pill duplication check for Most Popular
          // const pillExists = Array.from(
          //   document.querySelectorAll('.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]')
          // ).some(
          //   pill =>
          //     (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
          //       .trim()
          //       .toLowerCase() === normalizedValue
          // );
          // if (pillExists) return; // Already rendered as pill

          // Skip pill if a custom button already exists and is selected
          const quickBtn = Array.from(
            document.querySelectorAll(".quick-filter-main .custom-button a"),
          ).find((a) => {
            const btnUrl = new URL(a.href, location.origin)
            const btnVal = btnUrl.searchParams.get(
              "filter.p.m.custom.most_popular",
            )
            return btnVal && btnVal.trim().toLowerCase() === normalizedValue
          })
          if (quickBtn && quickBtn.classList.contains("selected")) {
            return
          }

          // Only show pill if option is checked in drawer
          const drawerCheckbox = Array.from(
            document.querySelectorAll(
              'input[name="filter.p.m.custom.most_popular"]',
            ),
          ).find(
            (input) =>
              decodeURIComponent(input.value).trim().toLowerCase() ===
              normalizedValue,
          )
          if (!drawerCheckbox || !drawerCheckbox.checked) return
        }
        let pill, label
        if (key === "sort_by" && !window.__isClearingFilters) {
          // EXTREME PROTECTION: Block ALL sort pill creation if sort pill was recently removed
          if (window.__sortPillRemoved) {
            return // Skip creating ANY sort pill if sort pill was recently removed
          }

          // EXTREME PROTECTION: Block ALL sort pill creation unless user explicitly selected Featured
          if (!window.userManuallySorted) {
            return // Skip creating ANY sort pill if user didn't explicitly select Featured
          }

          // Special handling for "Featured" (manual) sort: only create pill if user explicitly selected it
          if (value === "manual" && !window.userManuallySorted) {
            return // Skip creating Featured pill if user didn't explicitly select it
          }

          // Additional safety: double-check that manual sort is not being processed
          if (value === "manual" && !window.userManuallySorted) {
            return // Extra protection against Featured pill creation
          }

          // Human label for sort
          let sortLabel = value
          const sortRadio = document.querySelector(
            'input[name="sort_by"]:checked',
          )
          if (sortRadio) {
            let labelElem =
              document.querySelector(`label[for="${sortRadio.id}"]`) ||
              sortRadio.closest("label") ||
              sortRadio.parentElement
            if (labelElem) sortLabel = labelElem.textContent.trim()
          } else {
            const sortSelect = document.querySelector('select[name="sort_by"]')
            if (sortSelect) {
              const selected = sortSelect.querySelector("option:checked")
              if (selected) sortLabel = selected.textContent.trim()
            }
          }
          const fallbackSortLabels = {
            "best-selling": "Best Selling",
            "title-ascending": "Alphabetically, A–Z",
            "title-descending": "Alphabetically, Z–A",
            "price-ascending": "Price, Low to High",
            "price-descending": "Price, High to Low",
            "created-descending": "Date, new to old",
            "created-ascending": "Date, old to new",
            manual: "Featured",
          }
          if (!sortLabel || sortLabel === value) {
            sortLabel = fallbackSortLabels[value.toLowerCase()] || value
          }
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = sortLabel
          pill.setAttribute("data-sort-by", value.toLowerCase())
        } else if (key === "price") {
          const [min, max] = value.split("_")
          label = `Price: ${min ? currency + min : ""}${min && max ? " - " : ""}${max ? currency + max : ""}`
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = label
          pill.setAttribute("data-price", "1")
        } else if (key === "filter.p.m.custom.most_popular") {
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = value
          pill.dataset.p = `filter.p.m.custom.most_popular|${value}`
        } else {
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = value
          pill.dataset.p = key + "|" + value
        }
        // Insert every pill at the beginning so newest is always leftmost
        quickContainer.insertBefore(pill, quickContainer.firstChild)
        // [PATCH] Updated universal gutter logic for scroll when filter action triggered
        if (isFilterAction) {
          const isAndroid = /Android/i.test(navigator.userAgent || "")
          const isMobile =
            window.matchMedia && window.matchMedia("(max-width: 767px)").matches
          const isSortPill = pill.hasAttribute("data-sort-by")
          const container = document.querySelector(".quick-filter-main")

          if (container) {
            // Always enforce gutter for all pills
            let gutter = isMobile ? 16 : 40

            // For Android sort pills keep stronger gutter
            if (isAndroid && isMobile && isSortPill) {
              gutter = 16
            }

            const maxLeft = Math.max(
              0,
              container.scrollWidth - container.clientWidth,
            )
            const targetLeft = Math.max(
              0,
              Math.min(pill.offsetLeft - gutter, maxLeft),
            )
            container.scrollTo({ left: targetLeft, behavior: "smooth" })
          }

          isFilterAction = false
        }
      })

      // EXTREME PROTECTION: After all pills are rendered, remove any "Featured" pills if not explicitly selected
      if (!window.userManuallySorted) {
        const featuredPills = document.querySelectorAll(
          '.quick-filter-pill[data-sort-by="manual"]',
        )
        featuredPills.forEach((pill) => pill.remove())
      }
      // [PATCH] After all quick filter pills rendered, add event listeners for quick filter buttons to scroll into view on click
      document
        .querySelectorAll(".quick-filters-container .quick-filter-btn")
        .forEach((btn) => {
          btn.addEventListener("click", () => {
            // Custom scroll that respects padding
            const container = document.querySelector(".quick-filter-main")
            if (container) {
              const btnLeft = btn.offsetLeft
              const containerWidth = container.clientWidth
              const maxLeft = Math.max(
                0,
                container.scrollWidth - containerWidth,
              )

              // Get the current padding-left from CSS
              const computedStyle = window.getComputedStyle(container)
              const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0

              const targetLeft = Math.max(
                0,
                Math.min(btnLeft - paddingLeft, maxLeft),
              )
              container.scrollTo({ left: targetLeft, behavior: "smooth" })
            } else {
              btn.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start",
              })
            }
          })
        })
      // --- [NEW SCROLL LOGIC BLOCK] ---
      if (
        !suppressPillScroll &&
        pillOrderArr.length > 0 &&
        pillOrderArr[0][0] === "filter.p.m.custom.most_popular"
      ) {
        let mostPopularValue = decodeURIComponent(pillOrderArr[0][1])
          .trim()
          .toLowerCase()

        // Check if already in pills
        const pillExists = Array.from(
          document.querySelectorAll(
            '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
          ),
        ).some(
          (pill) =>
            (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
              .trim()
              .toLowerCase() === mostPopularValue,
        )

        // Check if already in selected quick filter button
        const quickBtn = Array.from(
          document.querySelectorAll(
            ".quick-filter-main .custom-button a.selected",
          ),
        ).some((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return btnVal && btnVal.trim().toLowerCase() === mostPopularValue
        })

        if (pillExists || quickBtn) {
          // Block ONLY the default left-snap; allow matched-button scroll to proceed
          window.blockLeftScrollThisRender = true
          // do not return here
        }
      }

      // Scroll as normal if NOT suppressed, and only if a filter was actually just applied
      if (
        !suppressPillScroll &&
        !window.__alreadyScrolledQuickFilter &&
        !window.preventNextQuickFilterScroll &&
        !window.blockLeftScrollThisRender &&
        (window.quickFilterJustAdded || isFilterAction) // quick filter click or any other filter change
      ) {
        const quickContainerElem = document.querySelector(".quick-filter-main")
        if (
          quickContainerElem &&
          quickContainerElem.offsetParent !== null &&
          quickContainerElem.offsetWidth > 0 &&
          quickContainerElem.offsetHeight > 0
        ) {
          // Scenario #2: non-quick filters — always scroll left
          if (isFilterAction) {
            // Use proper mobile gutter to preserve left padding
            const mobileGutter = getMobileGutterPx()
            scrollLeftCompat(quickContainerElem, true, mobileGutter)
            // Prevent a subsequent forced-snap from overriding the gutter
            window.forceScrollLeftAfterRender = false
            isFilterAction = false
            window.__quickFilterDesiredLeft = undefined
          }
          window.__suppressNextQuickFilterScroll = true
          window.__alreadyScrolledQuickFilter = true
          setTimeout(() => {
            window.__alreadyScrolledQuickFilter = false
          }, 150)
        }
      }

      // --- FORCED SCROLL: unmatched Most Popular add/remove should always snap left ---
      if (
        window.forceScrollLeftAfterRender &&
        (!window.blockLeftScrollThisRender || window.forceScrollPriority)
      ) {
        const quickContainerElem = document.querySelector(".quick-filter-main")
        if (
          quickContainerElem &&
          quickContainerElem.offsetParent !== null &&
          quickContainerElem.offsetWidth > 0 &&
          quickContainerElem.offsetHeight > 0
        ) {
          // Forced scenarios must always snap left, with mobile gutter
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(quickContainerElem, true, mobileGutter)
          window.__quickFilterDesiredLeft = undefined
          isFilterAction = false
        }
        window.forceScrollLeftAfterRender = false
        window.forceScrollLeftValue = null
        window.forceScrollPriority = false
      }

      // Reset preventQuickScroll flag after all pills are rendered, before any code that uses the flag
      window.preventQuickScroll = false
      window.preventNextQuickFilterScroll = false
      window.blockLeftScrollThisRender = false

      // Re-ensure gutter spacer after DOM changes
      try {
        if (isMobile()) {
          if (!quickContainer.querySelector(".quick-filter-gutter-spacer")) {
            const spacer = document.createElement("span")
            spacer.className = "quick-filter-gutter-spacer"
            spacer.style.flexShrink = "0"
            quickContainer.insertBefore(spacer, quickContainer.firstChild)
            updateQuickFilterSpacer(spacer)
          } else if (!window.__suppressContainerVisibilityToggleNextRender) {
            updateQuickFilterSpacer(
              quickContainer.querySelector(".quick-filter-gutter-spacer"),
            )
          }
        } else {
          const spacer = quickContainer.querySelector(
            ".quick-filter-gutter-spacer",
          )
          if (spacer) spacer.remove()
        }
      } catch (_) {}

      // Show quick filter container only if there is at least one real pill (ignore spacer)
      if (
        !window.__suppressContainerVisibilityToggleNextRender &&
        !window.__isClearingFilters
      ) {
        const pillCountForVisibility =
          quickContainer.querySelectorAll(".quick-filter-pill").length
        if (pillCountForVisibility > 0) {
          quickContainer.style.display = "flex"
        } else {
          quickContainer.style.display = "none"
        }
      }

      // Prevent Featured pill flicker during clear operations
      if (window.__isClearingFilters) {
        const qf = document.querySelector(".quick-filters-container")
        if (qf) {
          qf.style.visibility = ""
          // Force hide during clear to prevent double show/hide
          qf.style.display = "none"
        }
        window.__isClearingFilters = false
      }

      // Additional flicker prevention: suppress container visibility changes during clear
      if (window.__isClearingFilters) {
        window.__suppressContainerVisibilityToggleNextRender = true
      }

      // Removed unconditional scrollLeft/scrollTo after pill rendering (handled per-pill above)
      // Restore visibility after rebuild
      quickContainer.style.visibility = __prevVisibility || ""

      // Always reset the quick filter click flag after rendering completes (not a pill click)
      window.quickFilterClickPreventScroll = false
      // Reset the multiple-custom-block quick filter flag
      window.justClickedMultipleCustomBlockQuickFilter = false
      // Clear one-time suppress flag after render completes
      window.__suppressContainerVisibilityToggleNextRender = false

      // Show/hide Clear All button
      const isRealFilterActive = Object.keys(filters).some((key) => {
        if (key === "sort_by") return false
        const val = filters[key]
        return Array.isArray(val) && val.length > 0
      })
      clearAllBtn.style.display = isRealFilterActive ? "inline-block" : "none"

      // Update custom buttons
      document
        .querySelectorAll(".quick-filter-main .custom-button a")
        .forEach((a) => {
          const params = new URL(a.href).searchParams
          const [key, value] = params.entries().next().value || []
          a.classList.toggle("selected", !!filters[key]?.includes(value))
        })

      // Hide/show quick filter buttons based on active values
      const normalize = (str) =>
        str
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "")
      document
        .querySelectorAll(".quick-filter-main .custom-button a")
        .forEach((btn) => {
          const url = new URL(btn.href)
          const params = url.searchParams
          const filterKey = [...params.keys()].find((k) =>
            k.includes("filter.p.m.custom.most_popular"),
          )
          if (!filterKey) return
          const val = params.get(filterKey)
          const shouldShow = mostPopularOptionsFromResponse.some(
            (opt) => normalize(opt) === normalize(val),
          )
          const wrap = btn.closest(".custom-button")
          if (!wrap) return
          // If the rating filter marked this option as inapplicable, don't force-show it.
          if (wrap.getAttribute("data-hidden-by-rating") === "1") return
          wrap.style.display = shouldShow ? "inline-block" : "none"
        })

      // Attach mobile clear handler after rendering quick filters
      if (typeof attachMobileClearHandler === "function")
        attachMobileClearHandler()

      // Always reset the quick filter click flag after rendering completes
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null

      // Adjust gap based on pill count after rendering
      if (typeof window.adjustQuickFilterMainGap === "function") {
        window.adjustQuickFilterMainGap()
      } else if (typeof adjustQuickFilterMainGap === "function") {
        adjustQuickFilterMainGap()
      }
    }

    // Applies price filters from drawer inputs and triggers filter update
    function applyPriceFilters() {
      if (!drawerForm) return

      const minInput = drawerForm.querySelector(
        'input[name="filter.v.price.gte"]',
      )
      const maxInput = drawerForm.querySelector(
        'input[name="filter.v.price.lte"]',
      )
      const min = minInput?.value.trim()
      const max = maxInput?.value.trim()

      const filters = getFilters()

      // Add only if numeric and not empty
      if (min && !isNaN(min)) {
        filters["filter.v.price.gte"] = [min]
      } else {
        delete filters["filter.v.price.gte"]
      }

      if (max && !isNaN(max)) {
        filters["filter.v.price.lte"] = [max]
      } else {
        delete filters["filter.v.price.lte"]
      }

      // Optional validation
      if (min && max && parseFloat(min) > parseFloat(max)) {
        alert("Minimum price cannot be greater than maximum price")
        return
      }

      updateURL(filters)
    }

    // Event handlers
    if (drawerForm) {
      drawerForm.addEventListener("change", (e) => {
        if (!e.target.name) return
        if (!e.target.name.startsWith("filter.v.price")) {
          const isSort = e.target.name === "sort_by"
          const isMostPopular =
            e.target.name === "filter.p.m.custom.most_popular"
          // For all non-quick-filter drawer changes (including sort) that are not matched-MP add,
          // force left snap to be safe on iOS
          if (!isMostPopular) {
            const qfm = document.querySelector(".quick-filter-main")
            const gutter = getMobileGutterPx()
            // Stash desired left padding for render step
            window.__quickFilterDesiredLeft = gutter
            window.forceScrollLeftAfterRender = true
            window.forceScrollPriority = true
            window.blockLeftScrollThisRender = false
          }
          updateURL(getFilters())
          document.dispatchEvent(new Event("filter:change"))
        }
      })
    }

    quickContainer.addEventListener("click", (e) => {
      // Store the event globally for scroll logic
      window.quickFilterLastEvent = e
      const pill = e.target.closest(".quick-filter-pill")
      if (!pill) return
      localStorage.setItem("suppressNextPillScroll", "1")
      window.preventQuickScroll = true

      // Set robust global flag for quick filter pill click
      window.justClickedQuickFilter = true
      // Set scroll-prevent flag for quick filter pill click (legacy)
      window.quickFilterClickPreventScroll = true
      // Set new global skipScrollBecauseOfQuickFilterClick flag
      window.skipScrollBecauseOfQuickFilterClick = true
      setTimeout(() => {
        window.skipScrollBecauseOfQuickFilterClick = false
      }, 1000)

      // Remove neighbor capture logic per latest requirement
      window._neighborPillIndexAfterRemoval = null

      // --- Scroll suppression check BEFORE DOM update ---
      let shouldScroll = true
      if (
        pill &&
        pill.dataset.p &&
        pill.dataset.p.startsWith("filter.p.m.custom.most_popular|")
      ) {
        let value = pill.dataset.p.split("|")[1] || ""
        value = value.trim().toLowerCase().replace(/\+/g, " ")
        // Check for ANY quick filter button with this value
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          let btnVal = btnUrl.searchParams.get("filter.p.m.custom.most_popular")
          if (!btnVal) return false
          btnVal = btnVal.trim().toLowerCase().replace(/\+/g, " ")
          return btnVal === value
        })
        if (quickBtn) {
          shouldScroll = false
        }
      }
      // Set global flag for next render at the very top
      window.preventNextQuickFilterScroll = !shouldScroll

      const keyValue = pill.dataset.p
      let key, value
      if (keyValue) {
        ;[key, value] = keyValue.split("|")
      } else {
        key = pill.dataset.key
        value = pill.dataset.value
      }

      // --- Uncheck matching drawer input (checkbox/radio) before updating URL/content ---
      // New logic: Use data-p attribute if present, fallback to data-sort-by/data-price logic.
      if (pill.hasAttribute("data-p")) {
        const pillType = pill.getAttribute("data-p").split("|")[0]
        const pillValue = pill.getAttribute("data-p").split("|")[1]
        const drawerInputSelector = `[name="${pillType}"][value="${pillValue}"]`
        const drawerInput = document.querySelector(drawerInputSelector)
        if (drawerInput && drawerInput.checked) {
          drawerInput.click() // Simulate a click to uncheck and trigger change events
        }
      } else if (drawerForm) {
        // Fallback to old logic for legacy pills
        const checkbox = drawerForm.querySelector(
          `input[name="${key}"][value="${value}"]`,
        )
        if (checkbox) {
          checkbox.checked = false
          checkbox.dispatchEvent(new Event("change", { bubbles: true }))
        }
      }

      const filters = getFilters()

      // --- Update pill order array so that the removed/added pill is always leftmost (newest) ---
      let pillOrderArr = getPillOrderArr()
      pillOrderArr = pillOrderArr.filter(
        ([k, v]) => !(k === key && v === value),
      )

      // For sort pills, don't add them back to pillOrderArr when removing
      // For other pills, add them back to maintain order
      if (!pill.hasAttribute("data-sort-by")) {
        pillOrderArr.unshift([key, value])
      }

      setPillOrderArr(pillOrderArr)

      if (pill.hasAttribute("data-sort-by")) {
        // Deselect sort pill: ALWAYS snap left
        delete filters["sort_by"]

        // If removing "Featured" (manual) sort, reset the userManuallySorted flag
        if (value === "manual") {
          window.userManuallySorted = false

          // Also uncheck the "Featured" radio button in the form to prevent it from being re-added
          const featuredRadio = document.querySelector(
            'input[name="sort_by"][value="manual"]',
          )
          if (featuredRadio) {
            featuredRadio.checked = false
          }
        }

        // Additional safety: ensure no sort_by is in filters to prevent Featured pill creation
        delete filters["sort_by"]

        // Also ensure the pillOrderArr doesn't contain any sort_by entries
        let pillOrderArr = getPillOrderArr()
        pillOrderArr = pillOrderArr.filter(([k, v]) => k !== "sort_by")
        setPillOrderArr(pillOrderArr)

        // EXTREME PROTECTION: Set a flag to prevent any sort processing for this session
        window.__sortPillRemoved = true

        const qfm = document.querySelector(".quick-filter-main")
        const gutter = getMobileGutterPx()
        window.__quickFilterDesiredLeft = gutter
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        window.preventNextQuickFilterScroll = false
        updateURL(filters)
        setTimeout(() => {
          window.quickFilterClickPreventScroll = false
          window.justClickedQuickFilter = false
          window.skipScrollBecauseOfQuickFilterClick = false
        }, 1000)
        return
      }

      if (pill.hasAttribute("data-price")) {
        // Removing price pill: ALWAYS snap left
        delete filters["filter.v.price.gte"]
        delete filters["filter.v.price.lte"]
        if (drawerForm) {
          drawerForm
            .querySelectorAll('input[name^="filter.v.price"]')
            .forEach((i) => (i.value = ""))
        }
        const qfm = document.querySelector(".quick-filter-main")
        const gutter = getMobileGutterPx()
        window.__quickFilterDesiredLeft = gutter
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        window.preventNextQuickFilterScroll = false
      } else {
        if (filters[key]) {
          // Removing any other pill: ALWAYS snap left
          filters[key] = filters[key].filter((v) => v !== value)
          if (!filters[key].length) delete filters[key]
          const qfm = document.querySelector(".quick-filter-main")
          const gutter = getMobileGutterPx()
          window.__quickFilterDesiredLeft = gutter
          window.forceScrollLeftAfterRender = true
          window.forceScrollPriority = true
          window.blockLeftScrollThisRender = false
          window.preventNextQuickFilterScroll = false
        }
      }

      loadContent(filters)

      setTimeout(() => {
        // No scroll on quick filter click, always block scroll here
        window.preventQuickScroll = false
        window.quickFilterClickPreventScroll = false
        window.justClickedQuickFilter = false
        window.skipScrollBecauseOfQuickFilterClick = false
      }, 1000)
      toggleMobileClearButton()
    })

    clearAllBtn.addEventListener("click", () => {
      if (drawerForm) {
        drawerForm
          .querySelectorAll('input[type="checkbox"]')
          .forEach((cb) => (cb.checked = false))
        drawerForm
          .querySelectorAll('input[name^="filter.v.price"]')
          .forEach((i) => (i.value = ""))
      }
      // Reset user sort flags when clearing filters
      window.userManuallySorted = false
      window.userSelectedSort = false

      // Clear sort selection
      clearSortRadios()
      // Clear custom button filters
      document
        .querySelectorAll(".quick-filter-main .custom-button a.selected")
        .forEach((a) => {
          a.classList.remove("selected")
        })

      setPillOrderArr([]) // Clear pill order so no pill is rendered after clearing
      // For Clear Filters: use 16px gutter on mobile for the next render

      // After clearing, ensure gutter spacer is applied on next render
      window.__applyGutterSpacerNow = true
      document.dispatchEvent(new Event("filter:change"))
      updateURL({})
      setTimeout(() => {
        rebindShowMoreButton()
      }, 0)
      // Removed scroll-to-left logic here
    })

    // --- Add logic for .quick-filter-clear-all and .quick-filter-clear-all-mobile buttons ---
    document.querySelectorAll(".quick-filter-clear-all").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault()

        // Reset user sort flags when clearing filters
        window.userManuallySorted = false
        window.userSelectedSort = false

        const url = new URL(window.location.href)
        const params = url.searchParams
        const preserveParams = ["q", "options[prefix]"]
        const preserved = {}
        preserveParams.forEach((key) => {
          if (params.has(key)) preserved[key] = params.get(key)
        })
        ;[...params.keys()].forEach((key) => {
          if (!preserveParams.includes(key)) params.delete(key)
        })
        Object.keys(preserved).forEach((key) => {
          params.set(key, preserved[key])
        })
        history.pushState({}, "", `${url.pathname}?${params.toString()}`)
        if (typeof renderFilters === "function") {
          renderFilters()
        } else if (
          window.renderFilters &&
          typeof window.renderFilters === "function"
        ) {
          window.renderFilters()
        }
        if (!window.preventQuickScroll) {
          scrollQuickFilterMainLeft()
        }
        window.preventQuickScroll = false
      })
    })

    document
      .querySelectorAll(".quick-filter-main .custom-button a")
      .forEach((a) => {
        // Set the flag on both click and mousedown for best results
        a.addEventListener("mousedown", () => {
          window.justClickedQuickFilter = true
          window.justClickedQuickFilterTimestamp = Date.now()
          // New: set flag to indicate this is a quick filter button click
          window.justClickedMultipleCustomBlockQuickFilter = true
        })
        a.addEventListener("click", async (e) => {
          e.preventDefault()
          // Ensure this is the first statement in the click handler
          localStorage.setItem("suppressNextPillScroll", "1")
          // Store the event globally for scroll logic
          window.quickFilterLastEvent = e
          window.skipScrollOnQuickFilter = true
          // New: set flag to indicate this is a quick filter button click
          window.justClickedMultipleCustomBlockQuickFilter = true
          const params = new URL(a.href).searchParams
          const [key, value] = params.entries().next().value || []
          // Safety: if this pill doesn't actually carry a filter param, ignore it.
          if (!key || !value) return

          const filters = getFilters()
          filters[key] = filters[key] || []

          const isDeselection = filters[key].includes(value)
          const isSingleSelectQuickFilter = key === "yotpo_rating_min"

          if (isDeselection) {
            // Deselect: ALWAYS snap left with ~16px gutter (iOS-safe)
            window._lastQuickFilterClicked = null
            filters[key] = filters[key].filter((v) => v !== value)
            const qfm = document.querySelector(".quick-filter-main")
            const gutter = getMobileGutterPx()
            window.__quickFilterDesiredLeft = gutter
            window.forceScrollLeftAfterRender = true
            window.forceScrollPriority = true
            window.blockLeftScrollThisRender = false
            window.preventNextQuickFilterScroll = false
            // Prevent container visibility/spacer toggles this render to avoid flicker
            window.__suppressContainerVisibilityToggleNextRender = true
            // Collapse gutter spacer on deselect
            const spacer = document.querySelector(".quick-filter-gutter-spacer")
            if (spacer) updateQuickFilterSpacer(spacer)
          } else {
            // Selection: remember to center this quick filter button after render
            // Do not auto-scroll for rating quick filters (prevents the leftmost pill from being clipped).
            window._lastQuickFilterClicked =
              key === "yotpo_rating_min" ? null : { key, value }
            if (isSingleSelectQuickFilter) {
              // Rating quick filter: single select
              filters[key] = [value]
            } else {
              filters[key].push(value)
            }
          }

          if (!filters[key].length) delete filters[key]

          // Track quick filter pill order for re-add as leftmost (newest)
          let pillOrderArr = getPillOrderArr()
          pillOrderArr = pillOrderArr.filter(
            ([k, v]) => !(k === key && v === value),
          )
          pillOrderArr.unshift([key, value])
          setPillOrderArr(pillOrderArr)

          if (drawerForm) {
            const checkbox = drawerForm.querySelector(
              `input[name="${key}"][value="${value}"]`,
            )
            if (checkbox) checkbox.checked = !!filters[key]?.includes(value)
          }

          // 🔄 Update and reload
          window.quickFilterJustAdded = true
          await updateURL(filters)
          // No scroll-to-left or scrollQuickFilterMainLeft call here!
        })
      })

    // --- [SCROLL PATCH] Scroll clicked quick filter into view after click ---
    // Refactored: Instead of direct scroll here, set a global with the clicked value for renderQuick to handle
    document.addEventListener("click", function (e) {
      const pill = e.target.closest(".quick-filter-main .custom-button a")
      if (!pill) return
      // Avoid auto-scrolling for rating quick filters (it can leave the leftmost pill half-cut).
      if (pill.classList.contains("yotpo-rating-filter-pill")) return
      const filterValue = pill.getAttribute("data-filter-value")
      if (filterValue) {
        window._lastQuickFilterClickedValue = filterValue
      }
    })

    // Collapse gutter spacer on global clear actions
    document.addEventListener("click", function (e) {
      if (
        e.target.closest(".js-drawer-clear") ||
        e.target.closest(".mobile-facets__clear")
      ) {
        const spacer = document.querySelector(".quick-filter-gutter-spacer")
        if (spacer) updateQuickFilterSpacer(spacer, { forceCollapse: true })
      }
    })

    // Initialize
    setupPriceFilters()
    syncAll()
    // Removed scrollLeft reset for quick filters container on initial load
    // Run clear filters visibility logic once on load
    toggleClearFiltersVisibility()
    // Insert quick filters container positioning
    insertQuickFiltersContainer()
    // Inject clear filters button for mobile
    injectClearFiltersButtonMobile()
    // Enable mobile clear filters binding after button is created
    setTimeout(() => {
      bindMobileClearFilters()
    }, 50)
    // Enable pill container drag scrolling
    const pillContainer = document.querySelector(".quick-filter-main")
    if (pillContainer) {
      let isDown = false
      let startX
      let scrollLeft
      pillContainer.addEventListener("mousedown", (e) => {
        isDown = true
        pillContainer.classList.add("dragging")
        startX = e.pageX - pillContainer.offsetLeft
        scrollLeft = pillContainer.scrollLeft
      })
      pillContainer.addEventListener("mouseleave", () => {
        isDown = false
        pillContainer.classList.remove("dragging")
      })
      pillContainer.addEventListener("mouseup", () => {
        isDown = false
        pillContainer.classList.remove("dragging")
      })
      pillContainer.addEventListener("mousemove", (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - pillContainer.offsetLeft
        const walk = (x - startX) * 1.5
        pillContainer.scrollLeft = scrollLeft - walk
      })
    }
    window.addEventListener("resize", () => {
      if (window.suppressNextPillScroll) return
      const pillContainer = document.querySelector(".quick-filter-main")
      const firstPill = pillContainer?.querySelector(".quick-filter-pill")
      if (pillContainer && firstPill) {
        if (isFilterAction) {
          // Custom scroll that respects padding
          const computedStyle = window.getComputedStyle(pillContainer)
          const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0
          const btnLeft = firstPill.offsetLeft
          const containerWidth = pillContainer.clientWidth
          const maxLeft = Math.max(
            0,
            pillContainer.scrollWidth - containerWidth,
          )
          const targetLeft = Math.max(
            0,
            Math.min(btnLeft - paddingLeft, maxLeft),
          )
          pillContainer.scrollTo({ left: targetLeft, behavior: "smooth" })
          isFilterAction = false
        }
      }
    })
  })
  // ============================================================================
  // Clear All, Mobile/Drawer, Utility
  // ============================================================================
  // Injects a clear filters button for mobile view above the filter drawer
  function injectClearFiltersButtonMobile() {
    if (document.querySelector(".quick-filter-clear-all-mobile.in-header"))
      return

    const clearFilters =
      document.querySelector(".active-facets__button-remove").textContent ||
      "Clear Filters"
    const clearBtn = document.createElement("button")
    clearBtn.className =
      "quick-filter-clear-all quick-filter-clear-all-mobile in-header button button--tertiary"
    clearBtn.innerText = clearFilters
    clearBtn.style.display = "none"

    // Event listener is now handled in bindMobileClearFilters() to avoid conflicts and ensure proper blinking prevention
    // Removed backup event listener to prevent duplicate calls

    const mobileDrawer = document.querySelector(
      "menu-drawer.mobile-facets__wrapper",
    )
    if (mobileDrawer && mobileDrawer.parentNode) {
      mobileDrawer.parentNode.insertBefore(clearBtn, mobileDrawer)
    }
  }

  // Overrides price input behavior to trigger AJAX updates on blur/Enter/input
  function overridePriceInputsBehavior(form) {
    if (!form) return
    const minInput = form.querySelector('input[name="filter.v.price.gte"]')
    const maxInput = form.querySelector('input[name="filter.v.price.lte"]')
    const commitPrice = () => {
      const filters = getFilters()
      updateURL(filters)
    }
    if (minInput && !minInput.classList.contains("price-bound")) {
      minInput.addEventListener("input", (e) => e.stopPropagation())
      minInput.addEventListener("blur", commitPrice)
      minInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          commitPrice()
        }
      })
      minInput.classList.add("price-bound")
    }
    if (maxInput && !maxInput.classList.contains("price-bound")) {
      maxInput.addEventListener("input", (e) => e.stopPropagation())
      maxInput.addEventListener("blur", commitPrice)
      maxInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          commitPrice()
        }
      })
      maxInput.classList.add("price-bound")
    }
  }

  // Shows/hides clear filter buttons based on whether any filters are active (desktop & mobile)
  function toggleClearFiltersVisibility() {
    const urlParams = new URLSearchParams(window.location.search)
    const hasAnyFilter = [...urlParams.keys()].some(
      (key) => key.startsWith("filter.") || key === "sort_by",
    )

    // Also count the URL-driven rating quick filter as an active filter
    const hasRatingFilter = !!(urlParams.get("yotpo_rating_min") || "").trim()
    const shouldShow = hasAnyFilter || hasRatingFilter

    const desktopClear = document.querySelector(
      ".quick-filter-clear-all-desktop",
    )
    const mobileClear = document.querySelector(
      ".quick-filter-clear-all-mobile.in-header",
    )
    const quickClear = document.querySelector(
      ".quick-filter-clear-all:not(.in-header)",
    )

    if (desktopClear) {
      desktopClear.style.display =
        shouldShow && window.innerWidth > 767 ? "inline-block" : "none"
    }

    if (mobileClear) {
      mobileClear.style.display =
        shouldShow && window.innerWidth <= 767 ? "inline-block" : "none"
    }

    if (quickClear) {
      quickClear.style.display =
        window.innerWidth > 767 && shouldShow ? "inline-block" : "none"
    }

    // Adjust gap based on pill count after visibility changes
    if (typeof window.adjustQuickFilterMainGap === "function") {
      window.adjustQuickFilterMainGap()
    } else if (typeof adjustQuickFilterMainGap === "function") {
      adjustQuickFilterMainGap()
    }
  }

  // Adjusts the gap of quick-filter-main based on pill count
  function adjustQuickFilterMainGap() {
    const pillContainer = document.querySelector(".quick-filters-container")
    const mainContainer = document.querySelector(".quick-filter-main")

    if (pillContainer && mainContainer) {
      const pillCount =
        pillContainer.querySelectorAll(".quick-filter-pill").length

      if (pillCount > 0) {
        mainContainer.style.gap = "8px"
      } else {
        mainContainer.style.gap = "0px"
      }
    }
  }

  document.addEventListener("filters:updated", toggleClearFiltersVisibility)
  window.addEventListener("resize", toggleClearFiltersVisibility)
  window.addEventListener("popstate", toggleClearFiltersVisibility)

  const clearFilterObserver = new MutationObserver(() => {
    toggleClearFiltersVisibility()
  })
  clearFilterObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })

  // Binds mobile clear filters button to reset filters, update URL, and re-render pills
  function bindMobileClearFilters() {
    // Try multiple selectors to find the mobile clear button
    const mobileClearBtn =
      document.querySelector(".quick-filter-clear-all-mobile") ||
      document.querySelector(".quick-filter-clear-all-mobile.in-header") ||
      document.querySelector(".quick-filter-clear-all-mobile")

    if (!mobileClearBtn) {
      // Retry after a short delay if button not found
      setTimeout(bindMobileClearFilters, 100)
      return
    }

    mobileClearBtn.addEventListener("click", function (e) {
      e.preventDefault()

      // Use the existing working function instead of duplicating logic
      if (typeof resetAllFiltersAndReload === "function") {
        resetAllFiltersAndReload()
      } else if (typeof window.resetAllFiltersAndReload === "function") {
        window.resetAllFiltersAndReload()
      } else {
        // Fallback: manually implement the clear logic
        window.userManuallySorted = false
        window.userSelectedSort = false

        const url = new URL(window.location.href)
        url.search = ""
        history.replaceState({}, "", url.pathname)

        // Try to call the functions if they exist
        if (typeof window.loadContent === "function") {
          window.loadContent()
        }
        if (typeof window.renderFilters === "function") {
          window.renderFilters()
        }
      }
    })
  }

  document.addEventListener("filters:updated", toggleClearFiltersVisibility)
  document
    .querySelectorAll(".mobile-facets__footer .button--primary")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        setTimeout(toggleClearFiltersVisibility, 300)
      })
    })

  // Ensures the quick filters container is correctly inserted in the DOM after custom blocks
  function insertQuickFiltersContainer() {
    const container = document.querySelector(".quick-filter-main")
    const target = container?.querySelector(".multiple-custom-block")
    const pillsWrapper = document.querySelector(".quick-filters-container")

    if (pillsWrapper && target && container.contains(target)) {
      container.insertBefore(pillsWrapper, target)
    } else if (pillsWrapper && container) {
      container.appendChild(pillsWrapper)
    }
  }

  // ============================================================================
  // Show More Button Logic
  // ============================================================================
  // Handles AJAX loading and appending of more products when the "Show More" button is clicked
  function handleShowMoreClick(e) {
    e.preventDefault()
    try {
      e.stopImmediatePropagation()
      e.stopPropagation()
    } catch (_) {}
    const button = e.currentTarget

    let page = parseInt(button.dataset.page || "2")
    if (!page || isNaN(page)) page = 2

    const baseUrl =
      button.dataset.baseUrl || window.location.pathname.split("?")[0]
    const query = new URLSearchParams(window.location.search)
    query.delete("yotpo_rating_min")
    query.set("page", page)
    const url = `${baseUrl}?${query.toString()}`

    const grid =
      document.querySelector("#product-grid") ||
      document.querySelector("#ProductGridContainer")
    const countElem = document.querySelector(".custom-show-product")
    const totalElem = document.querySelector(".custom-total-product")
    const progress = document.querySelector(".load-more-progress-bar")
    const spinner = document.querySelector(".load-more-spinner")

    const isRatingMinActive = !!(
      new URLSearchParams(window.location.search).get("yotpo_rating_min") || ""
    ).trim()
    if (countElem && grid) {
      const selector = isRatingMinActive
        ? "li.grid__item:not(.daily-deals-injected):not(.yotpo-rating-filter-hidden)"
        : "li.grid__item:not(.daily-deals-injected)"
      const visibleProducts = grid.querySelectorAll(selector)
      countElem.textContent = visibleProducts.length.toString()
    }

    const totalCount = parseInt(totalElem?.textContent || "0")

    button.classList.add("hidden")
    button.dataset.page = (page + 1).toString()
    spinner?.classList.remove("hidden")

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const wrapper = document.createElement("div")
        wrapper.innerHTML = html

        const gridWrapper =
          wrapper.querySelector("#product-grid") ||
          wrapper.querySelector("#ProductGridContainer")
        const newItems = gridWrapper
          ? gridWrapper.querySelectorAll(
              "li.grid__item:not(.daily-deals-injected)",
            )
          : []
        // Use loaded DOM count (not the visible count) so pagination stays correct even when client-side filters hide items.
        const loadedCountBefore = grid
          ? grid.querySelectorAll("li.grid__item:not(.daily-deals-injected)")
              .length
          : 0
        let appendCount = 0
        newItems.forEach((item) => {
          grid.appendChild(item)
          appendCount++
        })
        if (typeof theme_custom?.percussiveMassageSlider === "function") {
          theme_custom.percussiveMassageSlider()
        }
        // After appending, update based on loaded DOM count so "page" math is correct.
        const loadedCountAfter = loadedCountBefore + appendCount
        const newTotalElem = wrapper.querySelector(".custom-total-product")
        if (newTotalElem && totalElem)
          totalElem.textContent = newTotalElem.textContent
        if (progress && totalElem) {
          const totalValue = parseInt(totalElem.textContent || "0")
          progress.style.width = `${(loadedCountAfter / totalValue) * 100}%`
        }

        const newLoadMore = wrapper.querySelector(".load-more-part")
        const curLoadMore = document.querySelector(".load-more-part")
        if (newLoadMore && curLoadMore) {
          curLoadMore.replaceWith(newLoadMore.cloneNode(true))
          // Now update the count after DOM replacement so it isn't overwritten
          const newCountElem = document.querySelector(".custom-show-product")
          const newTotalElemAfterReplace = document.querySelector(
            ".custom-total-product",
          )
          if (newCountElem) {
            const selector = isRatingMinActive
              ? "li.grid__item:not(.daily-deals-injected):not(.yotpo-rating-filter-hidden)"
              : "li.grid__item:not(.daily-deals-injected)"
            const visibleAfter = grid
              ? grid.querySelectorAll(selector).length
              : 0
            newCountElem.textContent = visibleAfter.toString()
          }
          if (newTotalElemAfterReplace && newTotalElem) {
            newTotalElemAfterReplace.textContent = newTotalElem.textContent
          }
          // Move rebindShowMoreButton call AFTER product cards are appended and inserted into the DOM
          setTimeout(function () {
            if (typeof rebindShowMoreButton === "function") {
              rebindShowMoreButton()
            }
          }, 0)

          // Update next button page from current grid count
          const newButton = document.querySelector(".load-more-btn")
          if (newButton) {
            const itemsPerPage = parseInt(
              document.querySelector(".custom-show-product")?.dataset.perPage ||
                "36",
            )
            const nextPage = Math.ceil(loadedCountAfter / itemsPerPage) + 1
            newButton.dataset.page = nextPage.toString()
          }
        }
        checkProductCardsPromoTextHeight()
        initBadges()
        // Ensure the "X of Y" UI is consistent after DOM replacement.
        try {
          syncLoadMoreUI()
        } catch (_) {}
      })
      .catch(() => {})
      .finally(() => {
        document.dispatchEvent(
          new Event("more:products:loaded", { bubbles: true, composed: true }),
        )
        spinner?.classList.add("hidden")
      })
  }

  // Rebinds the Show More button click handler after DOM replacement
  function rebindShowMoreButton() {
    const showMoreBtn = document.querySelector(".load-more-btn")
    if (showMoreBtn) {
      showMoreBtn.removeEventListener("click", handleShowMoreClick, true)
      showMoreBtn.addEventListener("click", handleShowMoreClick, true)
    }
  }
  window.rebindShowMoreButton = rebindShowMoreButton

  // ============================================================================
  // Miscellaneous/Global Event Handlers
  // ============================================================================
  // Global function assignments moved to DOMContentLoaded for earlier availability
  document.addEventListener("click", function (e) {
    const clearBtn = e.target.closest(".js-drawer-clear")
    if (clearBtn) {
      e.preventDefault()
      const clearURL = clearBtn.getAttribute("href")
      history.pushState({}, "", clearURL)
      // Hide the quick filter container during clear to avoid interim flicker
      try {
        window.__isClearingFilters = true
        const qf = document.querySelector(".quick-filters-container")
        if (qf) qf.style.visibility = "hidden"
      } catch (_) {}

      // Collapse/remove gutter immediately and suppress spacer on next render
      try {
        window.__applyGutterSpacerNow = false
        const spacer = document.querySelector(".quick-filter-gutter-spacer")
        if (spacer) updateQuickFilterSpacer(spacer, { forceCollapse: true })
      } catch (_) {}
      if (
        typeof FacetFiltersForm !== "undefined" &&
        typeof FacetFiltersForm.resetAllFilters === "function"
      ) {
        FacetFiltersForm.resetAllFilters()
      }
      if (typeof loadContent === "function") {
        loadContent(clearURL)
      } else if (typeof renderFilters === "function") {
        renderFilters()
      }
    }
  })

  // Binds the mobile drawer clear button to reset all filters and reload content
  function attachMobileClearHandler() {
    document.querySelectorAll(".mobile-facets__clear").forEach((btn) => {
      btn.removeEventListener("click", resetAllFiltersAndReload) // prevent duplicates
      btn.addEventListener("click", function (e) {
        e.preventDefault()
        resetAllFiltersAndReload()
        setTimeout(scrollQuickFilterMainLeft, 100)
      })
    })
  }

  attachMobileClearHandler()

  document.addEventListener("click", function (e) {
    const isMedia = e.target.closest(".card__media img")
    const isContent = e.target.closest(".card__content.card__content--top")
    const card = e.target.closest(".card[data-prod-url]")
    if (
      (isMedia || isContent) &&
      card &&
      !e.target.closest("a") &&
      !e.target.closest("button")
    ) {
      const url = card.getAttribute("data-prod-url")
      if (url) {
        window.location.href = url
      }
    }
  })
}

// --- [PATCH: Replace scrollIntoView for quick filter pills with custom mobile scroll logic] ---
if (!window.__customFilterFacetsPillClickScrollBound) {
  window.__customFilterFacetsPillClickScrollBound = true
  document.addEventListener(
    "click",
    function (e) {
      const pill = e.target.closest(".quick-filter-pill")
      if (!pill) return

      const container = pill.closest(".quick-filters-container")
      if (!container) return

      const pillRect = pill.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()

      // Calculate the amount to scroll so pill is fully in view
      const scrollOffset =
        pillRect.left -
        containerRect.left -
        containerRect.width / 2 +
        pillRect.width / 2

      container.scrollTo({
        left: container.scrollLeft + scrollOffset,
        behavior: "smooth",
      })
    },
    true,
  )
}
